import type * as Types from '../../generated/graphql-types';

import { gql } from '@apollo/client';
import { PessoaFieldsFragmentDoc, PessoaBasicFieldsFragmentDoc, FuncionarioFieldsFragmentDoc, AlunoFieldsFragmentDoc, ResponsavelFieldsFragmentDoc, PessoaAutorizadaFieldsFragmentDoc, CargoFieldsFragmentDoc, FuncionarioCargoFieldsFragmentDoc, UserCompleteFieldsFragmentDoc, UserFieldsFragmentDoc, VinculoFieldsFragmentDoc } from './fragments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetPessoasQueryVariables = Types.Exact<{
  pagination?: Types.InputMaybe<Types.PaginationInput>;
  where?: Types.InputMaybe<Types.QueryPessoaInput>;
}>;


export type GetPessoasQuery = { __typename: 'Query', pessoas: { __typename: 'PaginatedPessoaResponse', data: Array<{ __typename: 'PessoaType', id: number, nome: string, nomeSocial?: string | null, cpf?: string | null, dataNascimento?: any | null, email?: string | null, telefoneCelular?: string | null, telefoneFixo?: string | null, genero?: string | null, fotoUrl?: string | null, nomePai?: string | null, nomeMae?: string | null, emancipado: boolean, rg?: string | null, orgaoEmissor?: string | null, dataEmissaoRg?: any | null, cartaoSus?: string | null, profissao?: string | null, escolaridade?: string | null, religiao?: string | null, localTrabalho?: string | null, pontoReferencia?: string | null, certidaoMatricula?: string | null, certidaoTipo?: string | null, certidaoTermo?: string | null, certidaoLivro?: string | null, certidaoFolha?: string | null, certidaoCartorio?: string | null, certidaoMunicipio?: string | null, certidaoUf?: string | null, certidaoDataEmissao?: any | null, certidaoNascimento?: string | null, isRural: boolean, cep: string, logradouro: string, numero: string, complemento?: string | null, bairro: string, nacionalidade?: string | null, idiomaNativo?: string | null, dataChegadaBrasil?: any | null, nis?: string | null, passaporte?: string | null, status: Types.StatusPessoa, tituloEleitor?: string | null, zonaResidencial: Types.ZonaResidencial, criadoEm: any, atualizadoEm: any, cidade?: { __typename: 'MunicipioType', id: string, nome: string, uf: string } | null, naturalidade?: { __typename: 'MunicipioType', id: string, nome: string, uf: string } | null, raca?: { __typename: 'RacaType', id: string, nome: string } | null, estadoCivil?: { __typename: 'EstadoCivilType', id: number, nome: string } | null, tipoSanguineo?: { __typename: 'TipoSanguineoType', id: string, nome: string } | null, user?: { __typename: 'UserPessoaType', id: number, username: string } | null }>, meta: { __typename: 'PaginatedMetaDto', total: number, pageCount: number, page: number, limit: number } } };

export type GetPessoaByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type GetPessoaByIdQuery = { __typename: 'Query', pessoa?: { __typename: 'PessoaType', id: number, nome: string, nomeSocial?: string | null, cpf?: string | null, dataNascimento?: any | null, email?: string | null, telefoneCelular?: string | null, telefoneFixo?: string | null, genero?: string | null, fotoUrl?: string | null, nomePai?: string | null, nomeMae?: string | null, emancipado: boolean, rg?: string | null, orgaoEmissor?: string | null, dataEmissaoRg?: any | null, cartaoSus?: string | null, profissao?: string | null, escolaridade?: string | null, religiao?: string | null, localTrabalho?: string | null, pontoReferencia?: string | null, certidaoMatricula?: string | null, certidaoTipo?: string | null, certidaoTermo?: string | null, certidaoLivro?: string | null, certidaoFolha?: string | null, certidaoCartorio?: string | null, certidaoMunicipio?: string | null, certidaoUf?: string | null, certidaoDataEmissao?: any | null, certidaoNascimento?: string | null, isRural: boolean, cep: string, logradouro: string, numero: string, complemento?: string | null, bairro: string, nacionalidade?: string | null, idiomaNativo?: string | null, dataChegadaBrasil?: any | null, nis?: string | null, passaporte?: string | null, status: Types.StatusPessoa, tituloEleitor?: string | null, zonaResidencial: Types.ZonaResidencial, criadoEm: any, atualizadoEm: any, cidade?: { __typename: 'MunicipioType', id: string, nome: string, uf: string } | null, naturalidade?: { __typename: 'MunicipioType', id: string, nome: string, uf: string } | null, raca?: { __typename: 'RacaType', id: string, nome: string } | null, estadoCivil?: { __typename: 'EstadoCivilType', id: number, nome: string } | null, tipoSanguineo?: { __typename: 'TipoSanguineoType', id: string, nome: string } | null, user?: { __typename: 'UserPessoaType', id: number, username: string } | null } | null };

export type SearchPessoasByCpfQueryVariables = Types.Exact<{
  cpf: Types.Scalars['String']['input'];
}>;


export type SearchPessoasByCpfQuery = { __typename: 'Query', pessoas: { __typename: 'PaginatedPessoaResponse', data: Array<{ __typename: 'PessoaType', id: number, nome: string, nomeSocial?: string | null, cpf?: string | null, dataNascimento?: any | null, email?: string | null, telefoneCelular?: string | null, telefoneFixo?: string | null, genero?: string | null, fotoUrl?: string | null, nomePai?: string | null, nomeMae?: string | null, emancipado: boolean, rg?: string | null, orgaoEmissor?: string | null, dataEmissaoRg?: any | null, cartaoSus?: string | null, profissao?: string | null, escolaridade?: string | null, religiao?: string | null, localTrabalho?: string | null, pontoReferencia?: string | null, certidaoMatricula?: string | null, certidaoTipo?: string | null, certidaoTermo?: string | null, certidaoLivro?: string | null, certidaoFolha?: string | null, certidaoCartorio?: string | null, certidaoMunicipio?: string | null, certidaoUf?: string | null, certidaoDataEmissao?: any | null, certidaoNascimento?: string | null, isRural: boolean, cep: string, logradouro: string, numero: string, complemento?: string | null, bairro: string, nacionalidade?: string | null, idiomaNativo?: string | null, dataChegadaBrasil?: any | null, nis?: string | null, passaporte?: string | null, status: Types.StatusPessoa, tituloEleitor?: string | null, zonaResidencial: Types.ZonaResidencial, criadoEm: any, atualizadoEm: any, cidade?: { __typename: 'MunicipioType', id: string, nome: string, uf: string } | null, naturalidade?: { __typename: 'MunicipioType', id: string, nome: string, uf: string } | null, raca?: { __typename: 'RacaType', id: string, nome: string } | null, estadoCivil?: { __typename: 'EstadoCivilType', id: number, nome: string } | null, tipoSanguineo?: { __typename: 'TipoSanguineoType', id: string, nome: string } | null, user?: { __typename: 'UserPessoaType', id: number, username: string } | null }> } };

export type SearchPessoasByNameQueryVariables = Types.Exact<{
  nome: Types.Scalars['String']['input'];
}>;


export type SearchPessoasByNameQuery = { __typename: 'Query', pessoas: { __typename: 'PaginatedPessoaResponse', data: Array<{ __typename: 'PessoaType', id: number, nome: string, nomeSocial?: string | null, cpf?: string | null, email?: string | null, telefoneCelular?: string | null, telefoneFixo?: string | null, profissao?: string | null, escolaridade?: string | null, localTrabalho?: string | null, fotoUrl?: string | null, status: Types.StatusPessoa }> } };

export type GetFuncionariosQueryVariables = Types.Exact<{
  pagination?: Types.InputMaybe<Types.PaginationInput>;
  where?: Types.InputMaybe<Types.FuncionarioWhereInput>;
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetFuncionariosQuery = { __typename: 'Query', funcionarios: { __typename: 'PaginatedFuncionarioResponse', data: Array<{ __typename: 'FuncionarioType', id: number, matriculaFuncional: string, dataAdmissao?: any | null, status: string, pessoa?: { __typename: 'PessoaType', id: number, nome: string, nomeSocial?: string | null, cpf?: string | null, dataNascimento?: any | null, email?: string | null, telefoneCelular?: string | null, telefoneFixo?: string | null, genero?: string | null, fotoUrl?: string | null, nomePai?: string | null, nomeMae?: string | null, emancipado: boolean, rg?: string | null, orgaoEmissor?: string | null, dataEmissaoRg?: any | null, cartaoSus?: string | null, profissao?: string | null, escolaridade?: string | null, religiao?: string | null, localTrabalho?: string | null, pontoReferencia?: string | null, certidaoMatricula?: string | null, certidaoTipo?: string | null, certidaoTermo?: string | null, certidaoLivro?: string | null, certidaoFolha?: string | null, certidaoCartorio?: string | null, certidaoMunicipio?: string | null, certidaoUf?: string | null, certidaoDataEmissao?: any | null, certidaoNascimento?: string | null, isRural: boolean, cep: string, logradouro: string, numero: string, complemento?: string | null, bairro: string, nacionalidade?: string | null, idiomaNativo?: string | null, dataChegadaBrasil?: any | null, nis?: string | null, passaporte?: string | null, status: Types.StatusPessoa, tituloEleitor?: string | null, zonaResidencial: Types.ZonaResidencial, criadoEm: any, atualizadoEm: any, cidade?: { __typename: 'MunicipioType', id: string, nome: string, uf: string } | null, naturalidade?: { __typename: 'MunicipioType', id: string, nome: string, uf: string } | null, raca?: { __typename: 'RacaType', id: string, nome: string } | null, estadoCivil?: { __typename: 'EstadoCivilType', id: number, nome: string } | null, tipoSanguineo?: { __typename: 'TipoSanguineoType', id: string, nome: string } | null, user?: { __typename: 'UserPessoaType', id: number, username: string } | null } | null, escola?: { __typename: 'EscolaType', id: number, nomeFantasia: string } | null, cargos?: Array<{ __typename: 'FuncionarioCargoType', id: string, funcionarioId: number, cargoId: number, dataInicio: any, dataFim?: any | null, cargaHorariaSemanal: number, cargoPrincipal: boolean, ativo: boolean, salario?: number | null, cargo: { __typename: 'CargoType', id: string, nome: string, categoria: Types.CategoriaCargo, descricao?: string | null } }> | null }>, meta: { __typename: 'PaginatedMetaDto', total: number, pageCount: number, page: number, limit: number } } };

export type GetFuncionarioByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type GetFuncionarioByIdQuery = { __typename: 'Query', funcionario?: { __typename: 'FuncionarioType', id: number, matriculaFuncional: string, dataAdmissao?: any | null, status: string, pessoa?: { __typename: 'PessoaType', id: number, nome: string, nomeSocial?: string | null, cpf?: string | null, dataNascimento?: any | null, email?: string | null, telefoneCelular?: string | null, telefoneFixo?: string | null, genero?: string | null, fotoUrl?: string | null, nomePai?: string | null, nomeMae?: string | null, emancipado: boolean, rg?: string | null, orgaoEmissor?: string | null, dataEmissaoRg?: any | null, cartaoSus?: string | null, profissao?: string | null, escolaridade?: string | null, religiao?: string | null, localTrabalho?: string | null, pontoReferencia?: string | null, certidaoMatricula?: string | null, certidaoTipo?: string | null, certidaoTermo?: string | null, certidaoLivro?: string | null, certidaoFolha?: string | null, certidaoCartorio?: string | null, certidaoMunicipio?: string | null, certidaoUf?: string | null, certidaoDataEmissao?: any | null, certidaoNascimento?: string | null, isRural: boolean, cep: string, logradouro: string, numero: string, complemento?: string | null, bairro: string, nacionalidade?: string | null, idiomaNativo?: string | null, dataChegadaBrasil?: any | null, nis?: string | null, passaporte?: string | null, status: Types.StatusPessoa, tituloEleitor?: string | null, zonaResidencial: Types.ZonaResidencial, criadoEm: any, atualizadoEm: any, cidade?: { __typename: 'MunicipioType', id: string, nome: string, uf: string } | null, naturalidade?: { __typename: 'MunicipioType', id: string, nome: string, uf: string } | null, raca?: { __typename: 'RacaType', id: string, nome: string } | null, estadoCivil?: { __typename: 'EstadoCivilType', id: number, nome: string } | null, tipoSanguineo?: { __typename: 'TipoSanguineoType', id: string, nome: string } | null, user?: { __typename: 'UserPessoaType', id: number, username: string } | null } | null, escola?: { __typename: 'EscolaType', id: number, nomeFantasia: string } | null, cargos?: Array<{ __typename: 'FuncionarioCargoType', id: string, funcionarioId: number, cargoId: number, dataInicio: any, dataFim?: any | null, cargaHorariaSemanal: number, cargoPrincipal: boolean, ativo: boolean, salario?: number | null, cargo: { __typename: 'CargoType', id: string, nome: string, categoria: Types.CategoriaCargo, descricao?: string | null } }> | null } | null };

export type GetFuncionarioDetailQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type GetFuncionarioDetailQuery = { __typename: 'Query', funcionario?: { __typename: 'FuncionarioType', id: number, matriculaFuncional: string, dataAdmissao?: any | null, status: string, escola?: { __typename: 'EscolaType', id: number, nomeFantasia: string, nomeOficial?: string | null } | null, alocacoes?: Array<{ __typename: 'ProfessorTurmaDisciplinaType', id: number, turma: { __typename: 'TurmaType', id: number, nome: string }, disciplina: { __typename: 'DisciplinaType', id: number, nome: string } }> | null, vinculos?: Array<{ __typename: 'VinculoEscolaType', id: number, ativo: boolean, role?: { __typename: 'RoleVinculoType', id: number, nome: string } | null, escola?: { __typename: 'VinculoEscolaEscolaType', id: number, nomeFantasia: string } | null, secretaria?: { __typename: 'VinculoEscolaSecretariaType', id: number, nome: string } | null }> | null, pessoa?: { __typename: 'PessoaType', id: number, nome: string, nomeSocial?: string | null, cpf?: string | null, dataNascimento?: any | null, email?: string | null, telefoneCelular?: string | null, telefoneFixo?: string | null, genero?: string | null, fotoUrl?: string | null, nomePai?: string | null, nomeMae?: string | null, emancipado: boolean, rg?: string | null, orgaoEmissor?: string | null, dataEmissaoRg?: any | null, cartaoSus?: string | null, profissao?: string | null, escolaridade?: string | null, religiao?: string | null, localTrabalho?: string | null, pontoReferencia?: string | null, certidaoMatricula?: string | null, certidaoTipo?: string | null, certidaoTermo?: string | null, certidaoLivro?: string | null, certidaoFolha?: string | null, certidaoCartorio?: string | null, certidaoMunicipio?: string | null, certidaoUf?: string | null, certidaoDataEmissao?: any | null, certidaoNascimento?: string | null, isRural: boolean, cep: string, logradouro: string, numero: string, complemento?: string | null, bairro: string, nacionalidade?: string | null, idiomaNativo?: string | null, dataChegadaBrasil?: any | null, nis?: string | null, passaporte?: string | null, status: Types.StatusPessoa, tituloEleitor?: string | null, zonaResidencial: Types.ZonaResidencial, criadoEm: any, atualizadoEm: any, cidade?: { __typename: 'MunicipioType', id: string, nome: string, uf: string } | null, naturalidade?: { __typename: 'MunicipioType', id: string, nome: string, uf: string } | null, raca?: { __typename: 'RacaType', id: string, nome: string } | null, estadoCivil?: { __typename: 'EstadoCivilType', id: number, nome: string } | null, tipoSanguineo?: { __typename: 'TipoSanguineoType', id: string, nome: string } | null, user?: { __typename: 'UserPessoaType', id: number, username: string } | null } | null, cargos?: Array<{ __typename: 'FuncionarioCargoType', id: string, funcionarioId: number, cargoId: number, dataInicio: any, dataFim?: any | null, cargaHorariaSemanal: number, cargoPrincipal: boolean, ativo: boolean, salario?: number | null, cargo: { __typename: 'CargoType', id: string, nome: string, categoria: Types.CategoriaCargo, descricao?: string | null } }> | null } | null };

export type GetFuncionariosByEscolaQueryVariables = Types.Exact<{
  escolaId: Types.Scalars['Int']['input'];
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type GetFuncionariosByEscolaQuery = { __typename: 'Query', funcionarios: { __typename: 'PaginatedFuncionarioResponse', data: Array<{ __typename: 'FuncionarioType', id: number, matriculaFuncional: string, dataAdmissao?: any | null, status: string, pessoa?: { __typename: 'PessoaType', id: number, nome: string, nomeSocial?: string | null, cpf?: string | null, dataNascimento?: any | null, email?: string | null, telefoneCelular?: string | null, telefoneFixo?: string | null, genero?: string | null, fotoUrl?: string | null, nomePai?: string | null, nomeMae?: string | null, emancipado: boolean, rg?: string | null, orgaoEmissor?: string | null, dataEmissaoRg?: any | null, cartaoSus?: string | null, profissao?: string | null, escolaridade?: string | null, religiao?: string | null, localTrabalho?: string | null, pontoReferencia?: string | null, certidaoMatricula?: string | null, certidaoTipo?: string | null, certidaoTermo?: string | null, certidaoLivro?: string | null, certidaoFolha?: string | null, certidaoCartorio?: string | null, certidaoMunicipio?: string | null, certidaoUf?: string | null, certidaoDataEmissao?: any | null, certidaoNascimento?: string | null, isRural: boolean, cep: string, logradouro: string, numero: string, complemento?: string | null, bairro: string, nacionalidade?: string | null, idiomaNativo?: string | null, dataChegadaBrasil?: any | null, nis?: string | null, passaporte?: string | null, status: Types.StatusPessoa, tituloEleitor?: string | null, zonaResidencial: Types.ZonaResidencial, criadoEm: any, atualizadoEm: any, cidade?: { __typename: 'MunicipioType', id: string, nome: string, uf: string } | null, naturalidade?: { __typename: 'MunicipioType', id: string, nome: string, uf: string } | null, raca?: { __typename: 'RacaType', id: string, nome: string } | null, estadoCivil?: { __typename: 'EstadoCivilType', id: number, nome: string } | null, tipoSanguineo?: { __typename: 'TipoSanguineoType', id: string, nome: string } | null, user?: { __typename: 'UserPessoaType', id: number, username: string } | null } | null, escola?: { __typename: 'EscolaType', id: number, nomeFantasia: string } | null, cargos?: Array<{ __typename: 'FuncionarioCargoType', id: string, funcionarioId: number, cargoId: number, dataInicio: any, dataFim?: any | null, cargaHorariaSemanal: number, cargoPrincipal: boolean, ativo: boolean, salario?: number | null, cargo: { __typename: 'CargoType', id: string, nome: string, categoria: Types.CategoriaCargo, descricao?: string | null } }> | null }>, meta: { __typename: 'PaginatedMetaDto', total: number, pageCount: number, page: number, limit: number } } };

export type GetAlunosQueryVariables = Types.Exact<{
  pagination?: Types.InputMaybe<Types.PaginationInput>;
  where?: Types.InputMaybe<Types.AlunoWhereInput>;
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetAlunosQuery = { __typename: 'Query', alunos: { __typename: 'PaginatedAlunoResponse', data: Array<{ __typename: 'AlunoType', id: number, matricula: string, codigoInep?: string | null, matriculaLegado?: string | null, escolaOrigem?: string | null, modalidadeEnsino?: string | null, recebeBolsaFamilia?: boolean | null, autorizaUsoImagem?: boolean | null, laudoNeeEntregue?: boolean | null, possuiNee?: boolean | null, responsavelGuarda?: string | null, necessidadesEspeciais: Array<string>, recursosAcessibilidade: Array<string>, escolarizacaoForaEscola: boolean, justificativaFaltaDocumento?: string | null, usaTransporteEscolar: boolean, restricoesAlimentares?: Array<string> | null, deficiencias?: Array<{ __typename: 'MultiDeficienciaType', id: number, nome: string }> | null, pessoa?: { __typename: 'PessoaType', id: number, nome: string, nomeSocial?: string | null, cpf?: string | null, dataNascimento?: any | null, email?: string | null, telefoneCelular?: string | null, telefoneFixo?: string | null, genero?: string | null, fotoUrl?: string | null, nomePai?: string | null, nomeMae?: string | null, emancipado: boolean, rg?: string | null, orgaoEmissor?: string | null, dataEmissaoRg?: any | null, cartaoSus?: string | null, profissao?: string | null, escolaridade?: string | null, religiao?: string | null, localTrabalho?: string | null, pontoReferencia?: string | null, certidaoMatricula?: string | null, certidaoTipo?: string | null, certidaoTermo?: string | null, certidaoLivro?: string | null, certidaoFolha?: string | null, certidaoCartorio?: string | null, certidaoMunicipio?: string | null, certidaoUf?: string | null, certidaoDataEmissao?: any | null, certidaoNascimento?: string | null, isRural: boolean, cep: string, logradouro: string, numero: string, complemento?: string | null, bairro: string, nacionalidade?: string | null, idiomaNativo?: string | null, dataChegadaBrasil?: any | null, nis?: string | null, passaporte?: string | null, status: Types.StatusPessoa, tituloEleitor?: string | null, zonaResidencial: Types.ZonaResidencial, criadoEm: any, atualizadoEm: any, cidade?: { __typename: 'MunicipioType', id: string, nome: string, uf: string } | null, naturalidade?: { __typename: 'MunicipioType', id: string, nome: string, uf: string } | null, raca?: { __typename: 'RacaType', id: string, nome: string } | null, estadoCivil?: { __typename: 'EstadoCivilType', id: number, nome: string } | null, tipoSanguineo?: { __typename: 'TipoSanguineoType', id: string, nome: string } | null, user?: { __typename: 'UserPessoaType', id: number, username: string } | null } | null, matriculas: Array<{ __typename: 'MatriculaType', id: number, status: Types.StatusMatricula, dataMatricula: any, numeroMatricula?: string | null, rematricula: boolean, observacoes?: string | null, anoLetivo?: { __typename: 'AnoLetivoType', id: number, ano: number, dataInicio: any, dataFim: any } | null, turma: { __typename: 'TurmaType', id: number, nome: string, escola: { __typename: 'EscolaType', id: number, nomeFantasia: string }, curso: { __typename: 'CursoType', id: number, nome: string, etapaBNCC?: { __typename: 'BNCCEtapaType', id: number, nome: string } | null } } }>, responsaveis: Array<{ __typename: 'AlunoResponsavelType', id: number, grauParentesco: string, responsavelLegal: boolean, responsavelFinanceiro: boolean, responsavelAcademico: boolean, autorizadoBuscar: boolean, contatoEmergencia: boolean, guardaCompartilhada: boolean, prioridadeContato: number, observacoes?: string | null, ativo: boolean, pessoa?: { __typename: 'PessoaType', id: number, nome: string, nomeSocial?: string | null, cpf?: string | null, email?: string | null, telefoneCelular?: string | null, telefoneFixo?: string | null, profissao?: string | null, escolaridade?: string | null, localTrabalho?: string | null, fotoUrl?: string | null, status: Types.StatusPessoa } | null }>, pessoasAutorizadas?: Array<{ __typename: 'PessoaAutorizadaType', id: number, nome: string, documento?: string | null, parentesco?: string | null }> | null, fichaMedica?: { __typename: 'FichaMedicaType', id: number, alergias?: string | null, condicoesMedicas?: string | null, contatoEmergenciaNome?: string | null, contatoEmergenciaTelefone?: string | null, contatoEmergenciaParentesco?: string | null, laudosMedicos?: Array<string> | null, medicamentosContinuos?: string | null, emTratamentoMedico?: boolean | null, tiposTratamentoMedico?: string | null, doencasAnteriores?: string | null, tipoSanguineo?: string | null } | null }>, meta: { __typename: 'PaginatedMetaDto', total: number, pageCount: number, page: number, limit: number } } };

export type GetAlunoByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type GetAlunoByIdQuery = { __typename: 'Query', aluno?: { __typename: 'AlunoType', id: number, matricula: string, codigoInep?: string | null, matriculaLegado?: string | null, escolaOrigem?: string | null, modalidadeEnsino?: string | null, recebeBolsaFamilia?: boolean | null, autorizaUsoImagem?: boolean | null, laudoNeeEntregue?: boolean | null, possuiNee?: boolean | null, responsavelGuarda?: string | null, necessidadesEspeciais: Array<string>, recursosAcessibilidade: Array<string>, escolarizacaoForaEscola: boolean, justificativaFaltaDocumento?: string | null, usaTransporteEscolar: boolean, restricoesAlimentares?: Array<string> | null, deficiencias?: Array<{ __typename: 'MultiDeficienciaType', id: number, nome: string }> | null, pessoa?: { __typename: 'PessoaType', id: number, nome: string, nomeSocial?: string | null, cpf?: string | null, dataNascimento?: any | null, email?: string | null, telefoneCelular?: string | null, telefoneFixo?: string | null, genero?: string | null, fotoUrl?: string | null, nomePai?: string | null, nomeMae?: string | null, emancipado: boolean, rg?: string | null, orgaoEmissor?: string | null, dataEmissaoRg?: any | null, cartaoSus?: string | null, profissao?: string | null, escolaridade?: string | null, religiao?: string | null, localTrabalho?: string | null, pontoReferencia?: string | null, certidaoMatricula?: string | null, certidaoTipo?: string | null, certidaoTermo?: string | null, certidaoLivro?: string | null, certidaoFolha?: string | null, certidaoCartorio?: string | null, certidaoMunicipio?: string | null, certidaoUf?: string | null, certidaoDataEmissao?: any | null, certidaoNascimento?: string | null, isRural: boolean, cep: string, logradouro: string, numero: string, complemento?: string | null, bairro: string, nacionalidade?: string | null, idiomaNativo?: string | null, dataChegadaBrasil?: any | null, nis?: string | null, passaporte?: string | null, status: Types.StatusPessoa, tituloEleitor?: string | null, zonaResidencial: Types.ZonaResidencial, criadoEm: any, atualizadoEm: any, cidade?: { __typename: 'MunicipioType', id: string, nome: string, uf: string } | null, naturalidade?: { __typename: 'MunicipioType', id: string, nome: string, uf: string } | null, raca?: { __typename: 'RacaType', id: string, nome: string } | null, estadoCivil?: { __typename: 'EstadoCivilType', id: number, nome: string } | null, tipoSanguineo?: { __typename: 'TipoSanguineoType', id: string, nome: string } | null, user?: { __typename: 'UserPessoaType', id: number, username: string } | null } | null, matriculas: Array<{ __typename: 'MatriculaType', id: number, status: Types.StatusMatricula, dataMatricula: any, numeroMatricula?: string | null, rematricula: boolean, observacoes?: string | null, anoLetivo?: { __typename: 'AnoLetivoType', id: number, ano: number, dataInicio: any, dataFim: any } | null, turma: { __typename: 'TurmaType', id: number, nome: string, escola: { __typename: 'EscolaType', id: number, nomeFantasia: string }, curso: { __typename: 'CursoType', id: number, nome: string, etapaBNCC?: { __typename: 'BNCCEtapaType', id: number, nome: string } | null } } }>, responsaveis: Array<{ __typename: 'AlunoResponsavelType', id: number, grauParentesco: string, responsavelLegal: boolean, responsavelFinanceiro: boolean, responsavelAcademico: boolean, autorizadoBuscar: boolean, contatoEmergencia: boolean, guardaCompartilhada: boolean, prioridadeContato: number, observacoes?: string | null, ativo: boolean, pessoa?: { __typename: 'PessoaType', id: number, nome: string, nomeSocial?: string | null, cpf?: string | null, email?: string | null, telefoneCelular?: string | null, telefoneFixo?: string | null, profissao?: string | null, escolaridade?: string | null, localTrabalho?: string | null, fotoUrl?: string | null, status: Types.StatusPessoa } | null }>, pessoasAutorizadas?: Array<{ __typename: 'PessoaAutorizadaType', id: number, nome: string, documento?: string | null, parentesco?: string | null }> | null, fichaMedica?: { __typename: 'FichaMedicaType', id: number, alergias?: string | null, condicoesMedicas?: string | null, contatoEmergenciaNome?: string | null, contatoEmergenciaTelefone?: string | null, contatoEmergenciaParentesco?: string | null, laudosMedicos?: Array<string> | null, medicamentosContinuos?: string | null, emTratamentoMedico?: boolean | null, tiposTratamentoMedico?: string | null, doencasAnteriores?: string | null, tipoSanguineo?: string | null } | null } | null };

export type GetAlunosStatsQueryVariables = Types.Exact<{
  pagination?: Types.InputMaybe<Types.PaginationInput>;
  where?: Types.InputMaybe<Types.AlunoWhereInput>;
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetAlunosStatsQuery = { __typename: 'Query', alunos: { __typename: 'PaginatedAlunoResponse', data: Array<{ __typename: 'AlunoType', id: number, necessidadesEspeciais: Array<string>, usaTransporteEscolar: boolean, fichaMedica?: { __typename: 'FichaMedicaType', id: number } | null }>, meta: { __typename: 'PaginatedMetaDto', total: number } } };

export type SearchAlunoByMatriculaQueryVariables = Types.Exact<{
  matricula: Types.Scalars['String']['input'];
}>;


export type SearchAlunoByMatriculaQuery = { __typename: 'Query', alunos: { __typename: 'PaginatedAlunoResponse', data: Array<{ __typename: 'AlunoType', id: number, matricula: string, codigoInep?: string | null, matriculaLegado?: string | null, escolaOrigem?: string | null, modalidadeEnsino?: string | null, recebeBolsaFamilia?: boolean | null, autorizaUsoImagem?: boolean | null, laudoNeeEntregue?: boolean | null, possuiNee?: boolean | null, responsavelGuarda?: string | null, necessidadesEspeciais: Array<string>, recursosAcessibilidade: Array<string>, escolarizacaoForaEscola: boolean, justificativaFaltaDocumento?: string | null, usaTransporteEscolar: boolean, restricoesAlimentares?: Array<string> | null, deficiencias?: Array<{ __typename: 'MultiDeficienciaType', id: number, nome: string }> | null, pessoa?: { __typename: 'PessoaType', id: number, nome: string, nomeSocial?: string | null, cpf?: string | null, dataNascimento?: any | null, email?: string | null, telefoneCelular?: string | null, telefoneFixo?: string | null, genero?: string | null, fotoUrl?: string | null, nomePai?: string | null, nomeMae?: string | null, emancipado: boolean, rg?: string | null, orgaoEmissor?: string | null, dataEmissaoRg?: any | null, cartaoSus?: string | null, profissao?: string | null, escolaridade?: string | null, religiao?: string | null, localTrabalho?: string | null, pontoReferencia?: string | null, certidaoMatricula?: string | null, certidaoTipo?: string | null, certidaoTermo?: string | null, certidaoLivro?: string | null, certidaoFolha?: string | null, certidaoCartorio?: string | null, certidaoMunicipio?: string | null, certidaoUf?: string | null, certidaoDataEmissao?: any | null, certidaoNascimento?: string | null, isRural: boolean, cep: string, logradouro: string, numero: string, complemento?: string | null, bairro: string, nacionalidade?: string | null, idiomaNativo?: string | null, dataChegadaBrasil?: any | null, nis?: string | null, passaporte?: string | null, status: Types.StatusPessoa, tituloEleitor?: string | null, zonaResidencial: Types.ZonaResidencial, criadoEm: any, atualizadoEm: any, cidade?: { __typename: 'MunicipioType', id: string, nome: string, uf: string } | null, naturalidade?: { __typename: 'MunicipioType', id: string, nome: string, uf: string } | null, raca?: { __typename: 'RacaType', id: string, nome: string } | null, estadoCivil?: { __typename: 'EstadoCivilType', id: number, nome: string } | null, tipoSanguineo?: { __typename: 'TipoSanguineoType', id: string, nome: string } | null, user?: { __typename: 'UserPessoaType', id: number, username: string } | null } | null, matriculas: Array<{ __typename: 'MatriculaType', id: number, status: Types.StatusMatricula, dataMatricula: any, numeroMatricula?: string | null, rematricula: boolean, observacoes?: string | null, anoLetivo?: { __typename: 'AnoLetivoType', id: number, ano: number, dataInicio: any, dataFim: any } | null, turma: { __typename: 'TurmaType', id: number, nome: string, escola: { __typename: 'EscolaType', id: number, nomeFantasia: string }, curso: { __typename: 'CursoType', id: number, nome: string, etapaBNCC?: { __typename: 'BNCCEtapaType', id: number, nome: string } | null } } }>, responsaveis: Array<{ __typename: 'AlunoResponsavelType', id: number, grauParentesco: string, responsavelLegal: boolean, responsavelFinanceiro: boolean, responsavelAcademico: boolean, autorizadoBuscar: boolean, contatoEmergencia: boolean, guardaCompartilhada: boolean, prioridadeContato: number, observacoes?: string | null, ativo: boolean, pessoa?: { __typename: 'PessoaType', id: number, nome: string, nomeSocial?: string | null, cpf?: string | null, email?: string | null, telefoneCelular?: string | null, telefoneFixo?: string | null, profissao?: string | null, escolaridade?: string | null, localTrabalho?: string | null, fotoUrl?: string | null, status: Types.StatusPessoa } | null }>, pessoasAutorizadas?: Array<{ __typename: 'PessoaAutorizadaType', id: number, nome: string, documento?: string | null, parentesco?: string | null }> | null, fichaMedica?: { __typename: 'FichaMedicaType', id: number, alergias?: string | null, condicoesMedicas?: string | null, contatoEmergenciaNome?: string | null, contatoEmergenciaTelefone?: string | null, contatoEmergenciaParentesco?: string | null, laudosMedicos?: Array<string> | null, medicamentosContinuos?: string | null, emTratamentoMedico?: boolean | null, tiposTratamentoMedico?: string | null, doencasAnteriores?: string | null, tipoSanguineo?: string | null } | null }> } };

export type GetResponsaveisQueryVariables = Types.Exact<{
  pagination?: Types.InputMaybe<Types.PaginationInput>;
  where?: Types.InputMaybe<Types.ResponsavelWhereInput>;
}>;


export type GetResponsaveisQuery = { __typename: 'Query', responsaveis: { __typename: 'PaginatedResponsavelResponse', data: Array<{ __typename: 'ResponsavelType', id: number, pessoa: { __typename: 'PessoaType', id: number, nome: string, nomeSocial?: string | null, cpf?: string | null, dataNascimento?: any | null, email?: string | null, telefoneCelular?: string | null, telefoneFixo?: string | null, genero?: string | null, fotoUrl?: string | null, nomePai?: string | null, nomeMae?: string | null, emancipado: boolean, rg?: string | null, orgaoEmissor?: string | null, dataEmissaoRg?: any | null, cartaoSus?: string | null, profissao?: string | null, escolaridade?: string | null, religiao?: string | null, localTrabalho?: string | null, pontoReferencia?: string | null, certidaoMatricula?: string | null, certidaoTipo?: string | null, certidaoTermo?: string | null, certidaoLivro?: string | null, certidaoFolha?: string | null, certidaoCartorio?: string | null, certidaoMunicipio?: string | null, certidaoUf?: string | null, certidaoDataEmissao?: any | null, certidaoNascimento?: string | null, isRural: boolean, cep: string, logradouro: string, numero: string, complemento?: string | null, bairro: string, nacionalidade?: string | null, idiomaNativo?: string | null, dataChegadaBrasil?: any | null, nis?: string | null, passaporte?: string | null, status: Types.StatusPessoa, tituloEleitor?: string | null, zonaResidencial: Types.ZonaResidencial, criadoEm: any, atualizadoEm: any, cidade?: { __typename: 'MunicipioType', id: string, nome: string, uf: string } | null, naturalidade?: { __typename: 'MunicipioType', id: string, nome: string, uf: string } | null, raca?: { __typename: 'RacaType', id: string, nome: string } | null, estadoCivil?: { __typename: 'EstadoCivilType', id: number, nome: string } | null, tipoSanguineo?: { __typename: 'TipoSanguineoType', id: string, nome: string } | null, user?: { __typename: 'UserPessoaType', id: number, username: string } | null }, filhos: Array<{ __typename: 'ResponsaveisOnAlunosType', grauParentesco: string, aluno: { __typename: 'AlunoType', id: number, matricula: string, pessoa?: { __typename: 'PessoaType', id: number, nome: string, nomeSocial?: string | null, cpf?: string | null, email?: string | null, telefoneCelular?: string | null, telefoneFixo?: string | null, profissao?: string | null, escolaridade?: string | null, localTrabalho?: string | null, fotoUrl?: string | null, status: Types.StatusPessoa } | null } }> }>, meta: { __typename: 'PaginatedMetaDto', total: number, pageCount: number, page: number, limit: number } } };

export type GetResponsavelByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type GetResponsavelByIdQuery = { __typename: 'Query', responsavel?: { __typename: 'ResponsavelType', id: number, pessoa: { __typename: 'PessoaType', id: number, nome: string, nomeSocial?: string | null, cpf?: string | null, dataNascimento?: any | null, email?: string | null, telefoneCelular?: string | null, telefoneFixo?: string | null, genero?: string | null, fotoUrl?: string | null, nomePai?: string | null, nomeMae?: string | null, emancipado: boolean, rg?: string | null, orgaoEmissor?: string | null, dataEmissaoRg?: any | null, cartaoSus?: string | null, profissao?: string | null, escolaridade?: string | null, religiao?: string | null, localTrabalho?: string | null, pontoReferencia?: string | null, certidaoMatricula?: string | null, certidaoTipo?: string | null, certidaoTermo?: string | null, certidaoLivro?: string | null, certidaoFolha?: string | null, certidaoCartorio?: string | null, certidaoMunicipio?: string | null, certidaoUf?: string | null, certidaoDataEmissao?: any | null, certidaoNascimento?: string | null, isRural: boolean, cep: string, logradouro: string, numero: string, complemento?: string | null, bairro: string, nacionalidade?: string | null, idiomaNativo?: string | null, dataChegadaBrasil?: any | null, nis?: string | null, passaporte?: string | null, status: Types.StatusPessoa, tituloEleitor?: string | null, zonaResidencial: Types.ZonaResidencial, criadoEm: any, atualizadoEm: any, cidade?: { __typename: 'MunicipioType', id: string, nome: string, uf: string } | null, naturalidade?: { __typename: 'MunicipioType', id: string, nome: string, uf: string } | null, raca?: { __typename: 'RacaType', id: string, nome: string } | null, estadoCivil?: { __typename: 'EstadoCivilType', id: number, nome: string } | null, tipoSanguineo?: { __typename: 'TipoSanguineoType', id: string, nome: string } | null, user?: { __typename: 'UserPessoaType', id: number, username: string } | null }, filhos: Array<{ __typename: 'ResponsaveisOnAlunosType', grauParentesco: string, aluno: { __typename: 'AlunoType', id: number, matricula: string, pessoa?: { __typename: 'PessoaType', id: number, nome: string, nomeSocial?: string | null, cpf?: string | null, email?: string | null, telefoneCelular?: string | null, telefoneFixo?: string | null, profissao?: string | null, escolaridade?: string | null, localTrabalho?: string | null, fotoUrl?: string | null, status: Types.StatusPessoa } | null } }> } | null };

export type GetResponsaveisByAlunoQueryVariables = Types.Exact<{
  alunoId: Types.Scalars['Int']['input'];
}>;


export type GetResponsaveisByAlunoQuery = { __typename: 'Query', responsaveis: { __typename: 'PaginatedResponsavelResponse', data: Array<{ __typename: 'ResponsavelType', id: number, pessoa: { __typename: 'PessoaType', id: number, nome: string, nomeSocial?: string | null, cpf?: string | null, dataNascimento?: any | null, email?: string | null, telefoneCelular?: string | null, telefoneFixo?: string | null, genero?: string | null, fotoUrl?: string | null, nomePai?: string | null, nomeMae?: string | null, emancipado: boolean, rg?: string | null, orgaoEmissor?: string | null, dataEmissaoRg?: any | null, cartaoSus?: string | null, profissao?: string | null, escolaridade?: string | null, religiao?: string | null, localTrabalho?: string | null, pontoReferencia?: string | null, certidaoMatricula?: string | null, certidaoTipo?: string | null, certidaoTermo?: string | null, certidaoLivro?: string | null, certidaoFolha?: string | null, certidaoCartorio?: string | null, certidaoMunicipio?: string | null, certidaoUf?: string | null, certidaoDataEmissao?: any | null, certidaoNascimento?: string | null, isRural: boolean, cep: string, logradouro: string, numero: string, complemento?: string | null, bairro: string, nacionalidade?: string | null, idiomaNativo?: string | null, dataChegadaBrasil?: any | null, nis?: string | null, passaporte?: string | null, status: Types.StatusPessoa, tituloEleitor?: string | null, zonaResidencial: Types.ZonaResidencial, criadoEm: any, atualizadoEm: any, cidade?: { __typename: 'MunicipioType', id: string, nome: string, uf: string } | null, naturalidade?: { __typename: 'MunicipioType', id: string, nome: string, uf: string } | null, raca?: { __typename: 'RacaType', id: string, nome: string } | null, estadoCivil?: { __typename: 'EstadoCivilType', id: number, nome: string } | null, tipoSanguineo?: { __typename: 'TipoSanguineoType', id: string, nome: string } | null, user?: { __typename: 'UserPessoaType', id: number, username: string } | null }, filhos: Array<{ __typename: 'ResponsaveisOnAlunosType', grauParentesco: string, aluno: { __typename: 'AlunoType', id: number, matricula: string, pessoa?: { __typename: 'PessoaType', id: number, nome: string, nomeSocial?: string | null, cpf?: string | null, email?: string | null, telefoneCelular?: string | null, telefoneFixo?: string | null, profissao?: string | null, escolaridade?: string | null, localTrabalho?: string | null, fotoUrl?: string | null, status: Types.StatusPessoa } | null } }> }> } };

export type GetPessoasAutorizadasQueryVariables = Types.Exact<{
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type GetPessoasAutorizadasQuery = { __typename: 'Query', pessoasAutorizadas: { __typename: 'PaginatedPessoaAutorizadaResponse', data: Array<{ __typename: 'PessoaAutorizadaType', id: number, nome: string, documento?: string | null, parentesco?: string | null, aluno?: { __typename: 'AlunoType', id: number, matricula: string, pessoa?: { __typename: 'PessoaType', id: number, nome: string, nomeSocial?: string | null, cpf?: string | null, email?: string | null, telefoneCelular?: string | null, telefoneFixo?: string | null, profissao?: string | null, escolaridade?: string | null, localTrabalho?: string | null, fotoUrl?: string | null, status: Types.StatusPessoa } | null } | null }>, meta: { __typename: 'PaginatedMetaDto', total: number, pageCount: number, page: number, limit: number } } };

export type GetPessoasAutorizadasByAlunoQueryVariables = Types.Exact<{
  alunoId: Types.Scalars['Int']['input'];
}>;


export type GetPessoasAutorizadasByAlunoQuery = { __typename: 'Query', pessoasAutorizadas: { __typename: 'PaginatedPessoaAutorizadaResponse', data: Array<{ __typename: 'PessoaAutorizadaType', id: number, nome: string, documento?: string | null, parentesco?: string | null, aluno?: { __typename: 'AlunoType', id: number, matricula: string, pessoa?: { __typename: 'PessoaType', id: number, nome: string, nomeSocial?: string | null, cpf?: string | null, email?: string | null, telefoneCelular?: string | null, telefoneFixo?: string | null, profissao?: string | null, escolaridade?: string | null, localTrabalho?: string | null, fotoUrl?: string | null, status: Types.StatusPessoa } | null } | null }> } };

export type GetCargosQueryVariables = Types.Exact<{
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  where?: Types.InputMaybe<Types.QueryCargoInput>;
}>;


export type GetCargosQuery = { __typename: 'Query', cargos: { __typename: 'PaginatedCargoResponse', data: Array<{ __typename: 'CargoType', id: string, nome: string, categoria: Types.CategoriaCargo, descricao?: string | null, cargaHorariaPadrao: number, nivelHierarquico?: number | null, requerExperiencia: boolean, anosExperienciaMinima?: number | null, competenciasExigidas: Array<string>, salarioBase?: number | null, status: Types.StatusCargo, observacoes?: string | null, criadoEm: any, atualizadoEm: any }>, meta: { __typename: 'PageInfo', total: number, pageCount: number, page: number, limit: number } } };

export type GetCargoByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type GetCargoByIdQuery = { __typename: 'Query', cargo: { __typename: 'CargoType', id: string, nome: string, categoria: Types.CategoriaCargo, descricao?: string | null, cargaHorariaPadrao: number, nivelHierarquico?: number | null, requerExperiencia: boolean, anosExperienciaMinima?: number | null, competenciasExigidas: Array<string>, salarioBase?: number | null, status: Types.StatusCargo, observacoes?: string | null, criadoEm: any, atualizadoEm: any } };

export type GetCargosByCategoriaQueryVariables = Types.Exact<{
  categoria: Types.CategoriaCargo;
}>;


export type GetCargosByCategoriaQuery = { __typename: 'Query', cargosByCategoria: Array<{ __typename: 'CargoType', id: string, nome: string, categoria: Types.CategoriaCargo, descricao?: string | null, cargaHorariaPadrao: number, nivelHierarquico?: number | null, requerExperiencia: boolean, anosExperienciaMinima?: number | null, competenciasExigidas: Array<string>, salarioBase?: number | null, status: Types.StatusCargo, observacoes?: string | null, criadoEm: any, atualizadoEm: any }> };

export type GetCargosCompativeisQueryVariables = Types.Exact<{
  cargoId: Types.Scalars['Int']['input'];
}>;


export type GetCargosCompativeisQuery = { __typename: 'Query', cargosCompativeis: Array<{ __typename: 'CargoType', id: string, nome: string, categoria: Types.CategoriaCargo, descricao?: string | null, cargaHorariaPadrao: number, nivelHierarquico?: number | null, requerExperiencia: boolean, anosExperienciaMinima?: number | null, competenciasExigidas: Array<string>, salarioBase?: number | null, status: Types.StatusCargo, observacoes?: string | null, criadoEm: any, atualizadoEm: any }> };

export type GetFuncionarioCargosQueryVariables = Types.Exact<{
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  where?: Types.InputMaybe<Types.QueryFuncionarioCargoInput>;
}>;


export type GetFuncionarioCargosQuery = { __typename: 'Query', funcionarioCargos: { __typename: 'PaginatedFuncionarioCargoResponse', data: Array<{ __typename: 'FuncionarioCargoType', id: string, funcionarioId: number, cargoId: number, dataInicio: any, dataFim?: any | null, cargaHorariaSemanal: number, cargoPrincipal: boolean, ativo: boolean, salario?: number | null, certificacoesExigidas: Array<string>, documentosEntregues: Array<string>, observacoes?: string | null, criadoEm: any, atualizadoEm: any }>, meta: { __typename: 'PageInfo', total: number, pageCount: number, page: number, limit: number } } };

export type GetCargosByFuncionarioQueryVariables = Types.Exact<{
  funcionarioId: Types.Scalars['Int']['input'];
  apenasAtivos?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type GetCargosByFuncionarioQuery = { __typename: 'Query', cargosByFuncionario: Array<{ __typename: 'FuncionarioCargoType', id: string, funcionarioId: number, cargoId: number, dataInicio: any, dataFim?: any | null, cargaHorariaSemanal: number, cargoPrincipal: boolean, ativo: boolean, salario?: number | null, certificacoesExigidas: Array<string>, documentosEntregues: Array<string>, observacoes?: string | null, criadoEm: any, atualizadoEm: any }> };

export type GetFuncionariosByCargoQueryVariables = Types.Exact<{
  cargoId: Types.Scalars['Int']['input'];
  apenasAtivos?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type GetFuncionariosByCargoQuery = { __typename: 'Query', funcionariosByCargo: Array<{ __typename: 'FuncionarioCargoType', id: string, funcionarioId: number, cargoId: number, dataInicio: any, dataFim?: any | null, cargaHorariaSemanal: number, cargoPrincipal: boolean, ativo: boolean, salario?: number | null, certificacoesExigidas: Array<string>, documentosEntregues: Array<string>, observacoes?: string | null, criadoEm: any, atualizadoEm: any }> };

export type GetRacasQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetRacasQuery = { __typename: 'Query', getRacas: Array<{ __typename: 'RacaType', id: string, nome: string, codigo: string, descricao?: string | null }> };

export type GetTiposSanguineosQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetTiposSanguineosQuery = { __typename: 'Query', getTiposSanguineos: Array<{ __typename: 'TipoSanguineoType', id: string, tipo: string, fatorRh: string, nome: string }> };

export type GetEstadosCivisQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetEstadosCivisQuery = { __typename: 'Query', getEstadosCivis: Array<{ __typename: 'EstadoCivilLookupType', id: string, nome: string }> };

export type GetMultiDeficienciasQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetMultiDeficienciasQuery = { __typename: 'Query', multiDeficiencias: Array<{ __typename: 'MultiDeficienciaType', id: number, nome: string }> };

export type GetMunicipiosByUfQueryVariables = Types.Exact<{
  uf: Types.Scalars['String']['input'];
}>;


export type GetMunicipiosByUfQuery = { __typename: 'Query', getMunicipiosByUF: Array<{ __typename: 'MunicipioType', id: string, nome: string, codigoIbge?: string | null, uf: string, estado?: string | null }> };

export type GetUFsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetUFsQuery = { __typename: 'Query', getUFs: Array<{ __typename: 'UFType', codigo: string, nome: string, sigla: string }> };

export type GetNecessidadesEspeciaisQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetNecessidadesEspeciaisQuery = { __typename: 'Query', getNecessidadesEspeciais: Array<{ __typename: 'NecessidadeEspecialType', id: string, codigo: string, nome: string, descricao?: string | null, categoria: string }> };

export type GetGrausParentescoQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetGrausParentescoQuery = { __typename: 'Query', getGrausParentesco: Array<{ __typename: 'GrauParentescoType', id: string, nome: string, categoria: string, prioridade: number }> };

export type GetPessoaCompletaQueryVariables = Types.Exact<{
  pessoaId: Types.Scalars['Int']['input'];
}>;


export type GetPessoaCompletaQuery = { __typename: 'Query', pessoaCompleta: { __typename: 'PessoaCompletaView', permissoes: Array<string>, pessoa: { __typename: 'PessoaType', id: number, nome: string, nomeSocial?: string | null, cpf?: string | null, dataNascimento?: any | null, email?: string | null, telefoneCelular?: string | null, telefoneFixo?: string | null, genero?: string | null, fotoUrl?: string | null, nomePai?: string | null, nomeMae?: string | null, emancipado: boolean, rg?: string | null, orgaoEmissor?: string | null, dataEmissaoRg?: any | null, cartaoSus?: string | null, isRural: boolean, cep: string, logradouro: string, numero: string, complemento?: string | null, bairro: string, nacionalidade?: string | null, profissao?: string | null, escolaridade?: string | null, religiao?: string | null, localTrabalho?: string | null, pontoReferencia?: string | null, certidaoMatricula?: string | null, certidaoTipo?: string | null, certidaoTermo?: string | null, certidaoLivro?: string | null, certidaoFolha?: string | null, certidaoCartorio?: string | null, certidaoMunicipio?: string | null, certidaoUf?: string | null, certidaoDataEmissao?: any | null, nis?: string | null, passaporte?: string | null, status: Types.StatusPessoa, tituloEleitor?: string | null, zonaResidencial: Types.ZonaResidencial, certidaoNascimento?: string | null, dataChegadaBrasil?: any | null, idiomaNativo?: string | null, criadoEm: any, atualizadoEm: any, cidade?: { __typename: 'MunicipioType', id: string, nome: string, uf: string } | null, naturalidade?: { __typename: 'MunicipioType', id: string, nome: string, uf: string } | null, raca?: { __typename: 'RacaType', id: string, nome: string } | null, tipoSanguineo?: { __typename: 'TipoSanguineoType', id: string, nome: string } | null, user?: { __typename: 'UserPessoaType', id: number, username: string } | null }, user?: { __typename: 'User', id: string, username: string, email: string, ativo: boolean, criadoEm: any } | null, vinculos: Array<{ __typename: 'VinculoType', id: number, ativo: boolean, role: { __typename: 'RoleVinculoType', id: number, nome: string }, escola?: { __typename: 'EscolaType', id: number, nomeFantasia: string } | null, secretaria?: { __typename: 'SecretariaType', id: number, nome: string } | null }>, funcionario?: { __typename: 'FuncionarioType', id: number, matriculaFuncional: string, dataAdmissao?: any | null, status: string, escola?: { __typename: 'EscolaType', id: number, nomeFantasia: string } | null, cargos?: Array<{ __typename: 'FuncionarioCargoType', id: string, funcionarioId: number, cargoId: number, dataInicio: any, dataFim?: any | null, cargaHorariaSemanal: number, cargoPrincipal: boolean, ativo: boolean, salario?: number | null, cargo: { __typename: 'CargoType', id: string, nome: string, categoria: Types.CategoriaCargo, descricao?: string | null } }> | null } | null, aluno?: { __typename: 'AlunoType', id: number, matricula: string, codigoInep?: string | null, matriculaLegado?: string | null, escolaOrigem?: string | null, modalidadeEnsino?: string | null, recebeBolsaFamilia?: boolean | null, autorizaUsoImagem?: boolean | null, laudoNeeEntregue?: boolean | null, possuiNee?: boolean | null, responsavelGuarda?: string | null, pessoaId: number, necessidadesEspeciais: Array<string>, recursosAcessibilidade: Array<string>, escolarizacaoForaEscola: boolean, justificativaFaltaDocumento?: string | null, usaTransporteEscolar: boolean, restricoesAlimentares?: Array<string> | null, rotaTransporteId?: number | null, responsaveis: Array<{ __typename: 'AlunoResponsavelType', id: number, grauParentesco: string, responsavelLegal: boolean, responsavelFinanceiro: boolean, responsavelAcademico: boolean, autorizadoBuscar: boolean, contatoEmergencia: boolean, guardaCompartilhada: boolean, prioridadeContato: number, observacoes?: string | null, ativo: boolean, pessoa?: { __typename: 'PessoaType', id: number, nome: string, nomeSocial?: string | null, cpf?: string | null, email?: string | null, telefoneCelular?: string | null, telefoneFixo?: string | null, profissao?: string | null, escolaridade?: string | null, localTrabalho?: string | null, fotoUrl?: string | null, status: Types.StatusPessoa } | null }>, fichaMedica?: { __typename: 'FichaMedicaType', id: number, alunoId: number, alergias?: string | null, condicoesMedicas?: string | null, contatoEmergenciaNome?: string | null, contatoEmergenciaTelefone?: string | null, contatoEmergenciaParentesco?: string | null, laudosMedicos?: Array<string> | null, medicamentosContinuos?: string | null, emTratamentoMedico?: boolean | null, tiposTratamentoMedico?: string | null, doencasAnteriores?: string | null, tipoSanguineo?: string | null } | null, pessoasAutorizadas?: Array<{ __typename: 'PessoaAutorizadaType', id: number, alunoId: number, nome: string, documento?: string | null, parentesco?: string | null }> | null, matriculas: Array<{ __typename: 'MatriculaType', id: number, status: Types.StatusMatricula, turma: { __typename: 'TurmaType', id: number, nome: string, escola: { __typename: 'EscolaType', id: number, nomeFantasia: string } } }> } | null, responsavel?: { __typename: 'ResponsavelType', id: number } | null, contextInfo: { __typename: 'ContextInfo', isAluno: boolean, isFuncionario: boolean, isResponsavel: boolean, escolaIds: Array<number>, secretariaId?: number | null, activeRole?: string | null, canSwitchRoles: boolean } } };

export type SearchPessoasInteligenteQueryVariables = Types.Exact<{
  query: Types.Scalars['String']['input'];
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type SearchPessoasInteligenteQuery = { __typename: 'Query', pessoas: { __typename: 'PaginatedPessoaResponse', data: Array<{ __typename: 'PessoaType', id: number, nome: string, nomeSocial?: string | null, cpf?: string | null, email?: string | null, telefoneCelular?: string | null, telefoneFixo?: string | null, profissao?: string | null, escolaridade?: string | null, localTrabalho?: string | null, fotoUrl?: string | null, status: Types.StatusPessoa }> } };

export type GetAllPessoasForSearchQueryVariables = Types.Exact<{
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetAllPessoasForSearchQuery = { __typename: 'Query', pessoas: { __typename: 'PaginatedPessoaResponse', data: Array<{ __typename: 'PessoaType', id: number, nome: string, nomeSocial?: string | null, cpf?: string | null, email?: string | null, telefoneCelular?: string | null, telefoneFixo?: string | null, profissao?: string | null, escolaridade?: string | null, localTrabalho?: string | null, fotoUrl?: string | null, status: Types.StatusPessoa }> } };

export type GetPessoaVinculosQueryVariables = Types.Exact<{
  pessoaId: Types.Scalars['Int']['input'];
}>;


export type GetPessoaVinculosQuery = { __typename: 'Query', pessoa?: { __typename: 'PessoaType', id: number, nome: string, nomeSocial?: string | null, cpf?: string | null, dataNascimento?: any | null, email?: string | null, telefoneCelular?: string | null, telefoneFixo?: string | null, genero?: string | null, fotoUrl?: string | null, nomePai?: string | null, nomeMae?: string | null, emancipado: boolean, rg?: string | null, orgaoEmissor?: string | null, dataEmissaoRg?: any | null, cartaoSus?: string | null, profissao?: string | null, escolaridade?: string | null, religiao?: string | null, localTrabalho?: string | null, pontoReferencia?: string | null, certidaoMatricula?: string | null, certidaoTipo?: string | null, certidaoTermo?: string | null, certidaoLivro?: string | null, certidaoFolha?: string | null, certidaoCartorio?: string | null, certidaoMunicipio?: string | null, certidaoUf?: string | null, certidaoDataEmissao?: any | null, certidaoNascimento?: string | null, isRural: boolean, cep: string, logradouro: string, numero: string, complemento?: string | null, bairro: string, nacionalidade?: string | null, idiomaNativo?: string | null, dataChegadaBrasil?: any | null, nis?: string | null, passaporte?: string | null, status: Types.StatusPessoa, tituloEleitor?: string | null, zonaResidencial: Types.ZonaResidencial, criadoEm: any, atualizadoEm: any, cidade?: { __typename: 'MunicipioType', id: string, nome: string, uf: string } | null, naturalidade?: { __typename: 'MunicipioType', id: string, nome: string, uf: string } | null, raca?: { __typename: 'RacaType', id: string, nome: string } | null, estadoCivil?: { __typename: 'EstadoCivilType', id: number, nome: string } | null, tipoSanguineo?: { __typename: 'TipoSanguineoType', id: string, nome: string } | null, user?: { __typename: 'UserPessoaType', id: number, username: string } | null } | null, vinculos: { __typename: 'PaginatedVinculosResponseDto', data: Array<{ __typename: 'Vinculo', id: number, ativo: boolean, role: { __typename: 'RoleType', id: number, nome: string }, escola?: { __typename: 'EscolaType', id: number, nomeFantasia: string } | null, secretaria?: { __typename: 'SecretariaType', id: number, nome: string } | null, user: { __typename: 'User', id: string, username: string, pessoa: { __typename: 'PessoaType', id: number, nome: string, nomeSocial?: string | null, cpf?: string | null, email?: string | null, telefoneCelular?: string | null, telefoneFixo?: string | null, profissao?: string | null, escolaridade?: string | null, localTrabalho?: string | null, fotoUrl?: string | null, status: Types.StatusPessoa } } }> } };

export type GetUserCompleteQueryVariables = Types.Exact<{
  userId: Types.Scalars['Int']['input'];
}>;


export type GetUserCompleteQuery = { __typename: 'Query', user: { __typename: 'User', id: string, username: string, email: string, ativo: boolean, criadoEm: any, atualizadoEm: any, pessoa: { __typename: 'PessoaType', id: number, nome: string, nomeSocial?: string | null, cpf?: string | null, dataNascimento?: any | null, email?: string | null, telefoneCelular?: string | null, telefoneFixo?: string | null, genero?: string | null, fotoUrl?: string | null, nomePai?: string | null, nomeMae?: string | null, emancipado: boolean, rg?: string | null, orgaoEmissor?: string | null, dataEmissaoRg?: any | null, cartaoSus?: string | null, profissao?: string | null, escolaridade?: string | null, religiao?: string | null, localTrabalho?: string | null, pontoReferencia?: string | null, certidaoMatricula?: string | null, certidaoTipo?: string | null, certidaoTermo?: string | null, certidaoLivro?: string | null, certidaoFolha?: string | null, certidaoCartorio?: string | null, certidaoMunicipio?: string | null, certidaoUf?: string | null, certidaoDataEmissao?: any | null, certidaoNascimento?: string | null, isRural: boolean, cep: string, logradouro: string, numero: string, complemento?: string | null, bairro: string, nacionalidade?: string | null, idiomaNativo?: string | null, dataChegadaBrasil?: any | null, nis?: string | null, passaporte?: string | null, status: Types.StatusPessoa, tituloEleitor?: string | null, zonaResidencial: Types.ZonaResidencial, criadoEm: any, atualizadoEm: any, cidade?: { __typename: 'MunicipioType', id: string, nome: string, uf: string } | null, naturalidade?: { __typename: 'MunicipioType', id: string, nome: string, uf: string } | null, raca?: { __typename: 'RacaType', id: string, nome: string } | null, estadoCivil?: { __typename: 'EstadoCivilType', id: number, nome: string } | null, tipoSanguineo?: { __typename: 'TipoSanguineoType', id: string, nome: string } | null, user?: { __typename: 'UserPessoaType', id: number, username: string } | null }, vinculos: Array<{ __typename: 'VinculoType', id: number, ativo: boolean, role: { __typename: 'RoleVinculoType', id: number, nome: string }, escola?: { __typename: 'EscolaType', id: number, nomeFantasia: string } | null, secretaria?: { __typename: 'SecretariaType', id: number, nome: string } | null, user: { __typename: 'UserVinculoType', id: number, username: string, email: string } }> } };

export type GetUsersForPessoaQueryVariables = Types.Exact<{
  pagination?: Types.InputMaybe<Types.PaginationInput>;
  where?: Types.InputMaybe<Types.UserWhereInput>;
}>;


export type GetUsersForPessoaQuery = { __typename: 'Query', users: { __typename: 'PaginatedUserResponse', data: Array<{ __typename: 'User', id: string, username: string, email: string, ativo: boolean, criadoEm: any, atualizadoEm: any, pessoa: { __typename: 'PessoaType', id: number, nome: string, nomeSocial?: string | null, cpf?: string | null, email?: string | null, telefoneCelular?: string | null, telefoneFixo?: string | null, profissao?: string | null, escolaridade?: string | null, localTrabalho?: string | null, fotoUrl?: string | null, status: Types.StatusPessoa } }>, meta: { __typename: 'PageInfo', total: number, pageCount: number, page: number, limit: number } } };

export type GetVinculosByUserQueryVariables = Types.Exact<{
  userId: Types.Scalars['Int']['input'];
}>;


export type GetVinculosByUserQuery = { __typename: 'Query', vinculos: { __typename: 'PaginatedVinculosResponseDto', data: Array<{ __typename: 'Vinculo', id: number, userId: number, roleId: number, escolaId?: number | null, secretariaId?: number | null, ativo: boolean, criadoEm?: any | null, atualizadoEm?: any | null, role: { __typename: 'RoleType', id: number, nome: string }, escola?: { __typename: 'EscolaType', id: number, nomeFantasia: string } | null, secretaria?: { __typename: 'SecretariaType', id: number, nome: string } | null }> } };

export type GetVinculosRolesByEscolaQueryVariables = Types.Exact<{
  escolaId: Types.Scalars['Int']['input'];
}>;


export type GetVinculosRolesByEscolaQuery = { __typename: 'Query', vinculos: { __typename: 'PaginatedVinculosResponseDto', data: Array<{ __typename: 'Vinculo', id: number, userId: number, roleId: number, role: { __typename: 'RoleType', id: number, nome: string } }>, meta: { __typename: 'PaginatedMetaDto', total: number } } };

export type GetVinculosRolesBySecretariaQueryVariables = Types.Exact<{
  secretariaId: Types.Scalars['Int']['input'];
}>;


export type GetVinculosRolesBySecretariaQuery = { __typename: 'Query', vinculos: { __typename: 'PaginatedVinculosResponseDto', data: Array<{ __typename: 'Vinculo', id: number, userId: number, roleId: number, role: { __typename: 'RoleType', id: number, nome: string } }>, meta: { __typename: 'PaginatedMetaDto', total: number } } };

export type ValidarCpfQueryVariables = Types.Exact<{
  cpf: Types.Scalars['String']['input'];
  excludeId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type ValidarCpfQuery = { __typename: 'Query', validarCPF: { __typename: 'ValidarCPFResponse', valido: boolean, motivo?: string | null, pessoaExistente?: { __typename: 'PessoaType', id: number, nome: string, cpf?: string | null, email?: string | null } | null } };

export type VerificarDuplicatasQueryVariables = Types.Exact<{
  data: Types.VerificarDuplicatasInput;
  excludeId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type VerificarDuplicatasQuery = { __typename: 'Query', verificarDuplicatas: { __typename: 'VerificarDuplicatasResponse', podeProcessar: boolean, recomendacao?: string | null, duplicatas: Array<{ __typename: 'DuplicataInfo', campo: string, tipoConflito: string, valor: string, percentualSimilaridade: number, pessoaExistente: { __typename: 'PessoaType', id: number, nome: string, cpf?: string | null, email?: string | null } }> } };


export const GetPessoasDocument = gql`
    query GetPessoas($pagination: PaginationInput, $where: QueryPessoaInput) {
  pessoas(pagination: $pagination, where: $where) {
    data {
      ...PessoaFields
    }
    meta {
      total
      pageCount
      page
      limit
    }
  }
}
    ${PessoaFieldsFragmentDoc}`;

/**
 * __useGetPessoasQuery__
 *
 * To run a query within a React component, call `useGetPessoasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPessoasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPessoasQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetPessoasQuery(baseOptions?: Apollo.QueryHookOptions<GetPessoasQuery, GetPessoasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPessoasQuery, GetPessoasQueryVariables>(GetPessoasDocument, options);
      }
export function useGetPessoasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPessoasQuery, GetPessoasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPessoasQuery, GetPessoasQueryVariables>(GetPessoasDocument, options);
        }
export function useGetPessoasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPessoasQuery, GetPessoasQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPessoasQuery, GetPessoasQueryVariables>(GetPessoasDocument, options);
        }
export type GetPessoasQueryHookResult = ReturnType<typeof useGetPessoasQuery>;
export type GetPessoasLazyQueryHookResult = ReturnType<typeof useGetPessoasLazyQuery>;
export type GetPessoasSuspenseQueryHookResult = ReturnType<typeof useGetPessoasSuspenseQuery>;
export type GetPessoasQueryResult = Apollo.QueryResult<GetPessoasQuery, GetPessoasQueryVariables>;
export const GetPessoaByIdDocument = gql`
    query GetPessoaById($id: Int!) {
  pessoa(id: $id) {
    ...PessoaFields
  }
}
    ${PessoaFieldsFragmentDoc}`;

/**
 * __useGetPessoaByIdQuery__
 *
 * To run a query within a React component, call `useGetPessoaByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPessoaByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPessoaByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPessoaByIdQuery(baseOptions: Apollo.QueryHookOptions<GetPessoaByIdQuery, GetPessoaByIdQueryVariables> & ({ variables: GetPessoaByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPessoaByIdQuery, GetPessoaByIdQueryVariables>(GetPessoaByIdDocument, options);
      }
export function useGetPessoaByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPessoaByIdQuery, GetPessoaByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPessoaByIdQuery, GetPessoaByIdQueryVariables>(GetPessoaByIdDocument, options);
        }
export function useGetPessoaByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPessoaByIdQuery, GetPessoaByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPessoaByIdQuery, GetPessoaByIdQueryVariables>(GetPessoaByIdDocument, options);
        }
export type GetPessoaByIdQueryHookResult = ReturnType<typeof useGetPessoaByIdQuery>;
export type GetPessoaByIdLazyQueryHookResult = ReturnType<typeof useGetPessoaByIdLazyQuery>;
export type GetPessoaByIdSuspenseQueryHookResult = ReturnType<typeof useGetPessoaByIdSuspenseQuery>;
export type GetPessoaByIdQueryResult = Apollo.QueryResult<GetPessoaByIdQuery, GetPessoaByIdQueryVariables>;
export const SearchPessoasByCpfDocument = gql`
    query SearchPessoasByCpf($cpf: String!) {
  pessoas(where: {cpf: $cpf}) {
    data {
      ...PessoaFields
    }
  }
}
    ${PessoaFieldsFragmentDoc}`;

/**
 * __useSearchPessoasByCpfQuery__
 *
 * To run a query within a React component, call `useSearchPessoasByCpfQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPessoasByCpfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchPessoasByCpfQuery({
 *   variables: {
 *      cpf: // value for 'cpf'
 *   },
 * });
 */
export function useSearchPessoasByCpfQuery(baseOptions: Apollo.QueryHookOptions<SearchPessoasByCpfQuery, SearchPessoasByCpfQueryVariables> & ({ variables: SearchPessoasByCpfQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchPessoasByCpfQuery, SearchPessoasByCpfQueryVariables>(SearchPessoasByCpfDocument, options);
      }
export function useSearchPessoasByCpfLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchPessoasByCpfQuery, SearchPessoasByCpfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchPessoasByCpfQuery, SearchPessoasByCpfQueryVariables>(SearchPessoasByCpfDocument, options);
        }
export function useSearchPessoasByCpfSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchPessoasByCpfQuery, SearchPessoasByCpfQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchPessoasByCpfQuery, SearchPessoasByCpfQueryVariables>(SearchPessoasByCpfDocument, options);
        }
export type SearchPessoasByCpfQueryHookResult = ReturnType<typeof useSearchPessoasByCpfQuery>;
export type SearchPessoasByCpfLazyQueryHookResult = ReturnType<typeof useSearchPessoasByCpfLazyQuery>;
export type SearchPessoasByCpfSuspenseQueryHookResult = ReturnType<typeof useSearchPessoasByCpfSuspenseQuery>;
export type SearchPessoasByCpfQueryResult = Apollo.QueryResult<SearchPessoasByCpfQuery, SearchPessoasByCpfQueryVariables>;
export const SearchPessoasByNameDocument = gql`
    query SearchPessoasByName($nome: String!) {
  pessoas(where: {nome: $nome}) {
    data {
      ...PessoaBasicFields
    }
  }
}
    ${PessoaBasicFieldsFragmentDoc}`;

/**
 * __useSearchPessoasByNameQuery__
 *
 * To run a query within a React component, call `useSearchPessoasByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPessoasByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchPessoasByNameQuery({
 *   variables: {
 *      nome: // value for 'nome'
 *   },
 * });
 */
export function useSearchPessoasByNameQuery(baseOptions: Apollo.QueryHookOptions<SearchPessoasByNameQuery, SearchPessoasByNameQueryVariables> & ({ variables: SearchPessoasByNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchPessoasByNameQuery, SearchPessoasByNameQueryVariables>(SearchPessoasByNameDocument, options);
      }
export function useSearchPessoasByNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchPessoasByNameQuery, SearchPessoasByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchPessoasByNameQuery, SearchPessoasByNameQueryVariables>(SearchPessoasByNameDocument, options);
        }
export function useSearchPessoasByNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchPessoasByNameQuery, SearchPessoasByNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchPessoasByNameQuery, SearchPessoasByNameQueryVariables>(SearchPessoasByNameDocument, options);
        }
export type SearchPessoasByNameQueryHookResult = ReturnType<typeof useSearchPessoasByNameQuery>;
export type SearchPessoasByNameLazyQueryHookResult = ReturnType<typeof useSearchPessoasByNameLazyQuery>;
export type SearchPessoasByNameSuspenseQueryHookResult = ReturnType<typeof useSearchPessoasByNameSuspenseQuery>;
export type SearchPessoasByNameQueryResult = Apollo.QueryResult<SearchPessoasByNameQuery, SearchPessoasByNameQueryVariables>;
export const GetFuncionariosDocument = gql`
    query GetFuncionarios($pagination: PaginationInput, $where: FuncionarioWhereInput, $search: String) {
  funcionarios(pagination: $pagination, where: $where, search: $search) {
    data {
      ...FuncionarioFields
    }
    meta {
      total
      pageCount
      page
      limit
    }
  }
}
    ${FuncionarioFieldsFragmentDoc}`;

/**
 * __useGetFuncionariosQuery__
 *
 * To run a query within a React component, call `useGetFuncionariosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFuncionariosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFuncionariosQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      where: // value for 'where'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetFuncionariosQuery(baseOptions?: Apollo.QueryHookOptions<GetFuncionariosQuery, GetFuncionariosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFuncionariosQuery, GetFuncionariosQueryVariables>(GetFuncionariosDocument, options);
      }
export function useGetFuncionariosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFuncionariosQuery, GetFuncionariosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFuncionariosQuery, GetFuncionariosQueryVariables>(GetFuncionariosDocument, options);
        }
export function useGetFuncionariosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFuncionariosQuery, GetFuncionariosQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFuncionariosQuery, GetFuncionariosQueryVariables>(GetFuncionariosDocument, options);
        }
export type GetFuncionariosQueryHookResult = ReturnType<typeof useGetFuncionariosQuery>;
export type GetFuncionariosLazyQueryHookResult = ReturnType<typeof useGetFuncionariosLazyQuery>;
export type GetFuncionariosSuspenseQueryHookResult = ReturnType<typeof useGetFuncionariosSuspenseQuery>;
export type GetFuncionariosQueryResult = Apollo.QueryResult<GetFuncionariosQuery, GetFuncionariosQueryVariables>;
export const GetFuncionarioByIdDocument = gql`
    query GetFuncionarioById($id: Int!) {
  funcionario(id: $id) {
    ...FuncionarioFields
  }
}
    ${FuncionarioFieldsFragmentDoc}`;

/**
 * __useGetFuncionarioByIdQuery__
 *
 * To run a query within a React component, call `useGetFuncionarioByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFuncionarioByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFuncionarioByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFuncionarioByIdQuery(baseOptions: Apollo.QueryHookOptions<GetFuncionarioByIdQuery, GetFuncionarioByIdQueryVariables> & ({ variables: GetFuncionarioByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFuncionarioByIdQuery, GetFuncionarioByIdQueryVariables>(GetFuncionarioByIdDocument, options);
      }
export function useGetFuncionarioByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFuncionarioByIdQuery, GetFuncionarioByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFuncionarioByIdQuery, GetFuncionarioByIdQueryVariables>(GetFuncionarioByIdDocument, options);
        }
export function useGetFuncionarioByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFuncionarioByIdQuery, GetFuncionarioByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFuncionarioByIdQuery, GetFuncionarioByIdQueryVariables>(GetFuncionarioByIdDocument, options);
        }
export type GetFuncionarioByIdQueryHookResult = ReturnType<typeof useGetFuncionarioByIdQuery>;
export type GetFuncionarioByIdLazyQueryHookResult = ReturnType<typeof useGetFuncionarioByIdLazyQuery>;
export type GetFuncionarioByIdSuspenseQueryHookResult = ReturnType<typeof useGetFuncionarioByIdSuspenseQuery>;
export type GetFuncionarioByIdQueryResult = Apollo.QueryResult<GetFuncionarioByIdQuery, GetFuncionarioByIdQueryVariables>;
export const GetFuncionarioDetailDocument = gql`
    query GetFuncionarioDetail($id: Int!) {
  funcionario(id: $id) {
    ...FuncionarioFields
    escola {
      id
      nomeFantasia
      nomeOficial
    }
    alocacoes {
      id
      turma {
        id
        nome
      }
      disciplina {
        id
        nome
      }
    }
    vinculos {
      id
      ativo
      role {
        id
        nome
      }
      escola {
        id
        nomeFantasia
      }
      secretaria {
        id
        nome
      }
    }
  }
}
    ${FuncionarioFieldsFragmentDoc}`;

/**
 * __useGetFuncionarioDetailQuery__
 *
 * To run a query within a React component, call `useGetFuncionarioDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFuncionarioDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFuncionarioDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFuncionarioDetailQuery(baseOptions: Apollo.QueryHookOptions<GetFuncionarioDetailQuery, GetFuncionarioDetailQueryVariables> & ({ variables: GetFuncionarioDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFuncionarioDetailQuery, GetFuncionarioDetailQueryVariables>(GetFuncionarioDetailDocument, options);
      }
export function useGetFuncionarioDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFuncionarioDetailQuery, GetFuncionarioDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFuncionarioDetailQuery, GetFuncionarioDetailQueryVariables>(GetFuncionarioDetailDocument, options);
        }
export function useGetFuncionarioDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFuncionarioDetailQuery, GetFuncionarioDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFuncionarioDetailQuery, GetFuncionarioDetailQueryVariables>(GetFuncionarioDetailDocument, options);
        }
export type GetFuncionarioDetailQueryHookResult = ReturnType<typeof useGetFuncionarioDetailQuery>;
export type GetFuncionarioDetailLazyQueryHookResult = ReturnType<typeof useGetFuncionarioDetailLazyQuery>;
export type GetFuncionarioDetailSuspenseQueryHookResult = ReturnType<typeof useGetFuncionarioDetailSuspenseQuery>;
export type GetFuncionarioDetailQueryResult = Apollo.QueryResult<GetFuncionarioDetailQuery, GetFuncionarioDetailQueryVariables>;
export const GetFuncionariosByEscolaDocument = gql`
    query GetFuncionariosByEscola($escolaId: Int!, $pagination: PaginationInput) {
  funcionarios(pagination: $pagination, where: {escolaId: $escolaId}) {
    data {
      ...FuncionarioFields
    }
    meta {
      total
      pageCount
      page
      limit
    }
  }
}
    ${FuncionarioFieldsFragmentDoc}`;

/**
 * __useGetFuncionariosByEscolaQuery__
 *
 * To run a query within a React component, call `useGetFuncionariosByEscolaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFuncionariosByEscolaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFuncionariosByEscolaQuery({
 *   variables: {
 *      escolaId: // value for 'escolaId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetFuncionariosByEscolaQuery(baseOptions: Apollo.QueryHookOptions<GetFuncionariosByEscolaQuery, GetFuncionariosByEscolaQueryVariables> & ({ variables: GetFuncionariosByEscolaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFuncionariosByEscolaQuery, GetFuncionariosByEscolaQueryVariables>(GetFuncionariosByEscolaDocument, options);
      }
export function useGetFuncionariosByEscolaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFuncionariosByEscolaQuery, GetFuncionariosByEscolaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFuncionariosByEscolaQuery, GetFuncionariosByEscolaQueryVariables>(GetFuncionariosByEscolaDocument, options);
        }
export function useGetFuncionariosByEscolaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFuncionariosByEscolaQuery, GetFuncionariosByEscolaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFuncionariosByEscolaQuery, GetFuncionariosByEscolaQueryVariables>(GetFuncionariosByEscolaDocument, options);
        }
export type GetFuncionariosByEscolaQueryHookResult = ReturnType<typeof useGetFuncionariosByEscolaQuery>;
export type GetFuncionariosByEscolaLazyQueryHookResult = ReturnType<typeof useGetFuncionariosByEscolaLazyQuery>;
export type GetFuncionariosByEscolaSuspenseQueryHookResult = ReturnType<typeof useGetFuncionariosByEscolaSuspenseQuery>;
export type GetFuncionariosByEscolaQueryResult = Apollo.QueryResult<GetFuncionariosByEscolaQuery, GetFuncionariosByEscolaQueryVariables>;
export const GetAlunosDocument = gql`
    query GetAlunos($pagination: PaginationInput, $where: AlunoWhereInput, $search: String) {
  alunos(pagination: $pagination, where: $where, search: $search) {
    data {
      ...AlunoFields
    }
    meta {
      total
      pageCount
      page
      limit
    }
  }
}
    ${AlunoFieldsFragmentDoc}`;

/**
 * __useGetAlunosQuery__
 *
 * To run a query within a React component, call `useGetAlunosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlunosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAlunosQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      where: // value for 'where'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetAlunosQuery(baseOptions?: Apollo.QueryHookOptions<GetAlunosQuery, GetAlunosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAlunosQuery, GetAlunosQueryVariables>(GetAlunosDocument, options);
      }
export function useGetAlunosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAlunosQuery, GetAlunosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAlunosQuery, GetAlunosQueryVariables>(GetAlunosDocument, options);
        }
export function useGetAlunosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAlunosQuery, GetAlunosQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAlunosQuery, GetAlunosQueryVariables>(GetAlunosDocument, options);
        }
export type GetAlunosQueryHookResult = ReturnType<typeof useGetAlunosQuery>;
export type GetAlunosLazyQueryHookResult = ReturnType<typeof useGetAlunosLazyQuery>;
export type GetAlunosSuspenseQueryHookResult = ReturnType<typeof useGetAlunosSuspenseQuery>;
export type GetAlunosQueryResult = Apollo.QueryResult<GetAlunosQuery, GetAlunosQueryVariables>;
export const GetAlunoByIdDocument = gql`
    query GetAlunoById($id: Int!) {
  aluno(id: $id) {
    ...AlunoFields
  }
}
    ${AlunoFieldsFragmentDoc}`;

/**
 * __useGetAlunoByIdQuery__
 *
 * To run a query within a React component, call `useGetAlunoByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlunoByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAlunoByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAlunoByIdQuery(baseOptions: Apollo.QueryHookOptions<GetAlunoByIdQuery, GetAlunoByIdQueryVariables> & ({ variables: GetAlunoByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAlunoByIdQuery, GetAlunoByIdQueryVariables>(GetAlunoByIdDocument, options);
      }
export function useGetAlunoByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAlunoByIdQuery, GetAlunoByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAlunoByIdQuery, GetAlunoByIdQueryVariables>(GetAlunoByIdDocument, options);
        }
export function useGetAlunoByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAlunoByIdQuery, GetAlunoByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAlunoByIdQuery, GetAlunoByIdQueryVariables>(GetAlunoByIdDocument, options);
        }
export type GetAlunoByIdQueryHookResult = ReturnType<typeof useGetAlunoByIdQuery>;
export type GetAlunoByIdLazyQueryHookResult = ReturnType<typeof useGetAlunoByIdLazyQuery>;
export type GetAlunoByIdSuspenseQueryHookResult = ReturnType<typeof useGetAlunoByIdSuspenseQuery>;
export type GetAlunoByIdQueryResult = Apollo.QueryResult<GetAlunoByIdQuery, GetAlunoByIdQueryVariables>;
export const GetAlunosStatsDocument = gql`
    query GetAlunosStats($pagination: PaginationInput, $where: AlunoWhereInput, $search: String) {
  alunos(pagination: $pagination, where: $where, search: $search) {
    data {
      id
      necessidadesEspeciais
      usaTransporteEscolar
      fichaMedica {
        id
      }
    }
    meta {
      total
    }
  }
}
    `;

/**
 * __useGetAlunosStatsQuery__
 *
 * To run a query within a React component, call `useGetAlunosStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlunosStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAlunosStatsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      where: // value for 'where'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetAlunosStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetAlunosStatsQuery, GetAlunosStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAlunosStatsQuery, GetAlunosStatsQueryVariables>(GetAlunosStatsDocument, options);
      }
export function useGetAlunosStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAlunosStatsQuery, GetAlunosStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAlunosStatsQuery, GetAlunosStatsQueryVariables>(GetAlunosStatsDocument, options);
        }
export function useGetAlunosStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAlunosStatsQuery, GetAlunosStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAlunosStatsQuery, GetAlunosStatsQueryVariables>(GetAlunosStatsDocument, options);
        }
export type GetAlunosStatsQueryHookResult = ReturnType<typeof useGetAlunosStatsQuery>;
export type GetAlunosStatsLazyQueryHookResult = ReturnType<typeof useGetAlunosStatsLazyQuery>;
export type GetAlunosStatsSuspenseQueryHookResult = ReturnType<typeof useGetAlunosStatsSuspenseQuery>;
export type GetAlunosStatsQueryResult = Apollo.QueryResult<GetAlunosStatsQuery, GetAlunosStatsQueryVariables>;
export const SearchAlunoByMatriculaDocument = gql`
    query SearchAlunoByMatricula($matricula: String!) {
  alunos(where: {matricula: $matricula}) {
    data {
      ...AlunoFields
    }
  }
}
    ${AlunoFieldsFragmentDoc}`;

/**
 * __useSearchAlunoByMatriculaQuery__
 *
 * To run a query within a React component, call `useSearchAlunoByMatriculaQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAlunoByMatriculaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAlunoByMatriculaQuery({
 *   variables: {
 *      matricula: // value for 'matricula'
 *   },
 * });
 */
export function useSearchAlunoByMatriculaQuery(baseOptions: Apollo.QueryHookOptions<SearchAlunoByMatriculaQuery, SearchAlunoByMatriculaQueryVariables> & ({ variables: SearchAlunoByMatriculaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchAlunoByMatriculaQuery, SearchAlunoByMatriculaQueryVariables>(SearchAlunoByMatriculaDocument, options);
      }
export function useSearchAlunoByMatriculaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchAlunoByMatriculaQuery, SearchAlunoByMatriculaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchAlunoByMatriculaQuery, SearchAlunoByMatriculaQueryVariables>(SearchAlunoByMatriculaDocument, options);
        }
export function useSearchAlunoByMatriculaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchAlunoByMatriculaQuery, SearchAlunoByMatriculaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchAlunoByMatriculaQuery, SearchAlunoByMatriculaQueryVariables>(SearchAlunoByMatriculaDocument, options);
        }
export type SearchAlunoByMatriculaQueryHookResult = ReturnType<typeof useSearchAlunoByMatriculaQuery>;
export type SearchAlunoByMatriculaLazyQueryHookResult = ReturnType<typeof useSearchAlunoByMatriculaLazyQuery>;
export type SearchAlunoByMatriculaSuspenseQueryHookResult = ReturnType<typeof useSearchAlunoByMatriculaSuspenseQuery>;
export type SearchAlunoByMatriculaQueryResult = Apollo.QueryResult<SearchAlunoByMatriculaQuery, SearchAlunoByMatriculaQueryVariables>;
export const GetResponsaveisDocument = gql`
    query GetResponsaveis($pagination: PaginationInput, $where: ResponsavelWhereInput) {
  responsaveis(pagination: $pagination, where: $where) {
    data {
      ...ResponsavelFields
    }
    meta {
      total
      pageCount
      page
      limit
    }
  }
}
    ${ResponsavelFieldsFragmentDoc}`;

/**
 * __useGetResponsaveisQuery__
 *
 * To run a query within a React component, call `useGetResponsaveisQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResponsaveisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResponsaveisQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetResponsaveisQuery(baseOptions?: Apollo.QueryHookOptions<GetResponsaveisQuery, GetResponsaveisQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetResponsaveisQuery, GetResponsaveisQueryVariables>(GetResponsaveisDocument, options);
      }
export function useGetResponsaveisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetResponsaveisQuery, GetResponsaveisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetResponsaveisQuery, GetResponsaveisQueryVariables>(GetResponsaveisDocument, options);
        }
export function useGetResponsaveisSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetResponsaveisQuery, GetResponsaveisQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetResponsaveisQuery, GetResponsaveisQueryVariables>(GetResponsaveisDocument, options);
        }
export type GetResponsaveisQueryHookResult = ReturnType<typeof useGetResponsaveisQuery>;
export type GetResponsaveisLazyQueryHookResult = ReturnType<typeof useGetResponsaveisLazyQuery>;
export type GetResponsaveisSuspenseQueryHookResult = ReturnType<typeof useGetResponsaveisSuspenseQuery>;
export type GetResponsaveisQueryResult = Apollo.QueryResult<GetResponsaveisQuery, GetResponsaveisQueryVariables>;
export const GetResponsavelByIdDocument = gql`
    query GetResponsavelById($id: Int!) {
  responsavel(id: $id) {
    ...ResponsavelFields
  }
}
    ${ResponsavelFieldsFragmentDoc}`;

/**
 * __useGetResponsavelByIdQuery__
 *
 * To run a query within a React component, call `useGetResponsavelByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResponsavelByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResponsavelByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetResponsavelByIdQuery(baseOptions: Apollo.QueryHookOptions<GetResponsavelByIdQuery, GetResponsavelByIdQueryVariables> & ({ variables: GetResponsavelByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetResponsavelByIdQuery, GetResponsavelByIdQueryVariables>(GetResponsavelByIdDocument, options);
      }
export function useGetResponsavelByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetResponsavelByIdQuery, GetResponsavelByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetResponsavelByIdQuery, GetResponsavelByIdQueryVariables>(GetResponsavelByIdDocument, options);
        }
export function useGetResponsavelByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetResponsavelByIdQuery, GetResponsavelByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetResponsavelByIdQuery, GetResponsavelByIdQueryVariables>(GetResponsavelByIdDocument, options);
        }
export type GetResponsavelByIdQueryHookResult = ReturnType<typeof useGetResponsavelByIdQuery>;
export type GetResponsavelByIdLazyQueryHookResult = ReturnType<typeof useGetResponsavelByIdLazyQuery>;
export type GetResponsavelByIdSuspenseQueryHookResult = ReturnType<typeof useGetResponsavelByIdSuspenseQuery>;
export type GetResponsavelByIdQueryResult = Apollo.QueryResult<GetResponsavelByIdQuery, GetResponsavelByIdQueryVariables>;
export const GetResponsaveisByAlunoDocument = gql`
    query GetResponsaveisByAluno($alunoId: Int!) {
  responsaveis(where: {alunoId: $alunoId}) {
    data {
      ...ResponsavelFields
    }
  }
}
    ${ResponsavelFieldsFragmentDoc}`;

/**
 * __useGetResponsaveisByAlunoQuery__
 *
 * To run a query within a React component, call `useGetResponsaveisByAlunoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResponsaveisByAlunoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResponsaveisByAlunoQuery({
 *   variables: {
 *      alunoId: // value for 'alunoId'
 *   },
 * });
 */
export function useGetResponsaveisByAlunoQuery(baseOptions: Apollo.QueryHookOptions<GetResponsaveisByAlunoQuery, GetResponsaveisByAlunoQueryVariables> & ({ variables: GetResponsaveisByAlunoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetResponsaveisByAlunoQuery, GetResponsaveisByAlunoQueryVariables>(GetResponsaveisByAlunoDocument, options);
      }
export function useGetResponsaveisByAlunoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetResponsaveisByAlunoQuery, GetResponsaveisByAlunoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetResponsaveisByAlunoQuery, GetResponsaveisByAlunoQueryVariables>(GetResponsaveisByAlunoDocument, options);
        }
export function useGetResponsaveisByAlunoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetResponsaveisByAlunoQuery, GetResponsaveisByAlunoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetResponsaveisByAlunoQuery, GetResponsaveisByAlunoQueryVariables>(GetResponsaveisByAlunoDocument, options);
        }
export type GetResponsaveisByAlunoQueryHookResult = ReturnType<typeof useGetResponsaveisByAlunoQuery>;
export type GetResponsaveisByAlunoLazyQueryHookResult = ReturnType<typeof useGetResponsaveisByAlunoLazyQuery>;
export type GetResponsaveisByAlunoSuspenseQueryHookResult = ReturnType<typeof useGetResponsaveisByAlunoSuspenseQuery>;
export type GetResponsaveisByAlunoQueryResult = Apollo.QueryResult<GetResponsaveisByAlunoQuery, GetResponsaveisByAlunoQueryVariables>;
export const GetPessoasAutorizadasDocument = gql`
    query GetPessoasAutorizadas($pagination: PaginationInput) {
  pessoasAutorizadas(pagination: $pagination) {
    data {
      ...PessoaAutorizadaFields
    }
    meta {
      total
      pageCount
      page
      limit
    }
  }
}
    ${PessoaAutorizadaFieldsFragmentDoc}`;

/**
 * __useGetPessoasAutorizadasQuery__
 *
 * To run a query within a React component, call `useGetPessoasAutorizadasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPessoasAutorizadasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPessoasAutorizadasQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetPessoasAutorizadasQuery(baseOptions?: Apollo.QueryHookOptions<GetPessoasAutorizadasQuery, GetPessoasAutorizadasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPessoasAutorizadasQuery, GetPessoasAutorizadasQueryVariables>(GetPessoasAutorizadasDocument, options);
      }
export function useGetPessoasAutorizadasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPessoasAutorizadasQuery, GetPessoasAutorizadasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPessoasAutorizadasQuery, GetPessoasAutorizadasQueryVariables>(GetPessoasAutorizadasDocument, options);
        }
export function useGetPessoasAutorizadasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPessoasAutorizadasQuery, GetPessoasAutorizadasQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPessoasAutorizadasQuery, GetPessoasAutorizadasQueryVariables>(GetPessoasAutorizadasDocument, options);
        }
export type GetPessoasAutorizadasQueryHookResult = ReturnType<typeof useGetPessoasAutorizadasQuery>;
export type GetPessoasAutorizadasLazyQueryHookResult = ReturnType<typeof useGetPessoasAutorizadasLazyQuery>;
export type GetPessoasAutorizadasSuspenseQueryHookResult = ReturnType<typeof useGetPessoasAutorizadasSuspenseQuery>;
export type GetPessoasAutorizadasQueryResult = Apollo.QueryResult<GetPessoasAutorizadasQuery, GetPessoasAutorizadasQueryVariables>;
export const GetPessoasAutorizadasByAlunoDocument = gql`
    query GetPessoasAutorizadasByAluno($alunoId: Int!) {
  pessoasAutorizadas(where: {alunoId: $alunoId}) {
    data {
      ...PessoaAutorizadaFields
    }
  }
}
    ${PessoaAutorizadaFieldsFragmentDoc}`;

/**
 * __useGetPessoasAutorizadasByAlunoQuery__
 *
 * To run a query within a React component, call `useGetPessoasAutorizadasByAlunoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPessoasAutorizadasByAlunoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPessoasAutorizadasByAlunoQuery({
 *   variables: {
 *      alunoId: // value for 'alunoId'
 *   },
 * });
 */
export function useGetPessoasAutorizadasByAlunoQuery(baseOptions: Apollo.QueryHookOptions<GetPessoasAutorizadasByAlunoQuery, GetPessoasAutorizadasByAlunoQueryVariables> & ({ variables: GetPessoasAutorizadasByAlunoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPessoasAutorizadasByAlunoQuery, GetPessoasAutorizadasByAlunoQueryVariables>(GetPessoasAutorizadasByAlunoDocument, options);
      }
export function useGetPessoasAutorizadasByAlunoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPessoasAutorizadasByAlunoQuery, GetPessoasAutorizadasByAlunoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPessoasAutorizadasByAlunoQuery, GetPessoasAutorizadasByAlunoQueryVariables>(GetPessoasAutorizadasByAlunoDocument, options);
        }
export function useGetPessoasAutorizadasByAlunoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPessoasAutorizadasByAlunoQuery, GetPessoasAutorizadasByAlunoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPessoasAutorizadasByAlunoQuery, GetPessoasAutorizadasByAlunoQueryVariables>(GetPessoasAutorizadasByAlunoDocument, options);
        }
export type GetPessoasAutorizadasByAlunoQueryHookResult = ReturnType<typeof useGetPessoasAutorizadasByAlunoQuery>;
export type GetPessoasAutorizadasByAlunoLazyQueryHookResult = ReturnType<typeof useGetPessoasAutorizadasByAlunoLazyQuery>;
export type GetPessoasAutorizadasByAlunoSuspenseQueryHookResult = ReturnType<typeof useGetPessoasAutorizadasByAlunoSuspenseQuery>;
export type GetPessoasAutorizadasByAlunoQueryResult = Apollo.QueryResult<GetPessoasAutorizadasByAlunoQuery, GetPessoasAutorizadasByAlunoQueryVariables>;
export const GetCargosDocument = gql`
    query GetCargos($page: Int, $limit: Int, $where: QueryCargoInput) {
  cargos(page: $page, limit: $limit, where: $where) {
    data {
      ...CargoFields
    }
    meta {
      total
      pageCount
      page
      limit
    }
  }
}
    ${CargoFieldsFragmentDoc}`;

/**
 * __useGetCargosQuery__
 *
 * To run a query within a React component, call `useGetCargosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCargosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCargosQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetCargosQuery(baseOptions?: Apollo.QueryHookOptions<GetCargosQuery, GetCargosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCargosQuery, GetCargosQueryVariables>(GetCargosDocument, options);
      }
export function useGetCargosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCargosQuery, GetCargosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCargosQuery, GetCargosQueryVariables>(GetCargosDocument, options);
        }
export function useGetCargosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCargosQuery, GetCargosQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCargosQuery, GetCargosQueryVariables>(GetCargosDocument, options);
        }
export type GetCargosQueryHookResult = ReturnType<typeof useGetCargosQuery>;
export type GetCargosLazyQueryHookResult = ReturnType<typeof useGetCargosLazyQuery>;
export type GetCargosSuspenseQueryHookResult = ReturnType<typeof useGetCargosSuspenseQuery>;
export type GetCargosQueryResult = Apollo.QueryResult<GetCargosQuery, GetCargosQueryVariables>;
export const GetCargoByIdDocument = gql`
    query GetCargoById($id: Int!) {
  cargo(id: $id) {
    ...CargoFields
  }
}
    ${CargoFieldsFragmentDoc}`;

/**
 * __useGetCargoByIdQuery__
 *
 * To run a query within a React component, call `useGetCargoByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCargoByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCargoByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCargoByIdQuery(baseOptions: Apollo.QueryHookOptions<GetCargoByIdQuery, GetCargoByIdQueryVariables> & ({ variables: GetCargoByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCargoByIdQuery, GetCargoByIdQueryVariables>(GetCargoByIdDocument, options);
      }
export function useGetCargoByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCargoByIdQuery, GetCargoByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCargoByIdQuery, GetCargoByIdQueryVariables>(GetCargoByIdDocument, options);
        }
export function useGetCargoByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCargoByIdQuery, GetCargoByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCargoByIdQuery, GetCargoByIdQueryVariables>(GetCargoByIdDocument, options);
        }
export type GetCargoByIdQueryHookResult = ReturnType<typeof useGetCargoByIdQuery>;
export type GetCargoByIdLazyQueryHookResult = ReturnType<typeof useGetCargoByIdLazyQuery>;
export type GetCargoByIdSuspenseQueryHookResult = ReturnType<typeof useGetCargoByIdSuspenseQuery>;
export type GetCargoByIdQueryResult = Apollo.QueryResult<GetCargoByIdQuery, GetCargoByIdQueryVariables>;
export const GetCargosByCategoriaDocument = gql`
    query GetCargosByCategoria($categoria: CategoriaCargo!) {
  cargosByCategoria(categoria: $categoria) {
    ...CargoFields
  }
}
    ${CargoFieldsFragmentDoc}`;

/**
 * __useGetCargosByCategoriaQuery__
 *
 * To run a query within a React component, call `useGetCargosByCategoriaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCargosByCategoriaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCargosByCategoriaQuery({
 *   variables: {
 *      categoria: // value for 'categoria'
 *   },
 * });
 */
export function useGetCargosByCategoriaQuery(baseOptions: Apollo.QueryHookOptions<GetCargosByCategoriaQuery, GetCargosByCategoriaQueryVariables> & ({ variables: GetCargosByCategoriaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCargosByCategoriaQuery, GetCargosByCategoriaQueryVariables>(GetCargosByCategoriaDocument, options);
      }
export function useGetCargosByCategoriaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCargosByCategoriaQuery, GetCargosByCategoriaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCargosByCategoriaQuery, GetCargosByCategoriaQueryVariables>(GetCargosByCategoriaDocument, options);
        }
export function useGetCargosByCategoriaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCargosByCategoriaQuery, GetCargosByCategoriaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCargosByCategoriaQuery, GetCargosByCategoriaQueryVariables>(GetCargosByCategoriaDocument, options);
        }
export type GetCargosByCategoriaQueryHookResult = ReturnType<typeof useGetCargosByCategoriaQuery>;
export type GetCargosByCategoriaLazyQueryHookResult = ReturnType<typeof useGetCargosByCategoriaLazyQuery>;
export type GetCargosByCategoriaSuspenseQueryHookResult = ReturnType<typeof useGetCargosByCategoriaSuspenseQuery>;
export type GetCargosByCategoriaQueryResult = Apollo.QueryResult<GetCargosByCategoriaQuery, GetCargosByCategoriaQueryVariables>;
export const GetCargosCompativeisDocument = gql`
    query GetCargosCompativeis($cargoId: Int!) {
  cargosCompativeis(cargoId: $cargoId) {
    ...CargoFields
  }
}
    ${CargoFieldsFragmentDoc}`;

/**
 * __useGetCargosCompativeisQuery__
 *
 * To run a query within a React component, call `useGetCargosCompativeisQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCargosCompativeisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCargosCompativeisQuery({
 *   variables: {
 *      cargoId: // value for 'cargoId'
 *   },
 * });
 */
export function useGetCargosCompativeisQuery(baseOptions: Apollo.QueryHookOptions<GetCargosCompativeisQuery, GetCargosCompativeisQueryVariables> & ({ variables: GetCargosCompativeisQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCargosCompativeisQuery, GetCargosCompativeisQueryVariables>(GetCargosCompativeisDocument, options);
      }
export function useGetCargosCompativeisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCargosCompativeisQuery, GetCargosCompativeisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCargosCompativeisQuery, GetCargosCompativeisQueryVariables>(GetCargosCompativeisDocument, options);
        }
export function useGetCargosCompativeisSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCargosCompativeisQuery, GetCargosCompativeisQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCargosCompativeisQuery, GetCargosCompativeisQueryVariables>(GetCargosCompativeisDocument, options);
        }
export type GetCargosCompativeisQueryHookResult = ReturnType<typeof useGetCargosCompativeisQuery>;
export type GetCargosCompativeisLazyQueryHookResult = ReturnType<typeof useGetCargosCompativeisLazyQuery>;
export type GetCargosCompativeisSuspenseQueryHookResult = ReturnType<typeof useGetCargosCompativeisSuspenseQuery>;
export type GetCargosCompativeisQueryResult = Apollo.QueryResult<GetCargosCompativeisQuery, GetCargosCompativeisQueryVariables>;
export const GetFuncionarioCargosDocument = gql`
    query GetFuncionarioCargos($page: Int, $limit: Int, $where: QueryFuncionarioCargoInput) {
  funcionarioCargos(page: $page, limit: $limit, where: $where) {
    data {
      ...FuncionarioCargoFields
    }
    meta {
      total
      pageCount
      page
      limit
    }
  }
}
    ${FuncionarioCargoFieldsFragmentDoc}`;

/**
 * __useGetFuncionarioCargosQuery__
 *
 * To run a query within a React component, call `useGetFuncionarioCargosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFuncionarioCargosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFuncionarioCargosQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetFuncionarioCargosQuery(baseOptions?: Apollo.QueryHookOptions<GetFuncionarioCargosQuery, GetFuncionarioCargosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFuncionarioCargosQuery, GetFuncionarioCargosQueryVariables>(GetFuncionarioCargosDocument, options);
      }
export function useGetFuncionarioCargosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFuncionarioCargosQuery, GetFuncionarioCargosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFuncionarioCargosQuery, GetFuncionarioCargosQueryVariables>(GetFuncionarioCargosDocument, options);
        }
export function useGetFuncionarioCargosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFuncionarioCargosQuery, GetFuncionarioCargosQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFuncionarioCargosQuery, GetFuncionarioCargosQueryVariables>(GetFuncionarioCargosDocument, options);
        }
export type GetFuncionarioCargosQueryHookResult = ReturnType<typeof useGetFuncionarioCargosQuery>;
export type GetFuncionarioCargosLazyQueryHookResult = ReturnType<typeof useGetFuncionarioCargosLazyQuery>;
export type GetFuncionarioCargosSuspenseQueryHookResult = ReturnType<typeof useGetFuncionarioCargosSuspenseQuery>;
export type GetFuncionarioCargosQueryResult = Apollo.QueryResult<GetFuncionarioCargosQuery, GetFuncionarioCargosQueryVariables>;
export const GetCargosByFuncionarioDocument = gql`
    query GetCargosByFuncionario($funcionarioId: Int!, $apenasAtivos: Boolean = true) {
  cargosByFuncionario(funcionarioId: $funcionarioId, apenasAtivos: $apenasAtivos) {
    ...FuncionarioCargoFields
  }
}
    ${FuncionarioCargoFieldsFragmentDoc}`;

/**
 * __useGetCargosByFuncionarioQuery__
 *
 * To run a query within a React component, call `useGetCargosByFuncionarioQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCargosByFuncionarioQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCargosByFuncionarioQuery({
 *   variables: {
 *      funcionarioId: // value for 'funcionarioId'
 *      apenasAtivos: // value for 'apenasAtivos'
 *   },
 * });
 */
export function useGetCargosByFuncionarioQuery(baseOptions: Apollo.QueryHookOptions<GetCargosByFuncionarioQuery, GetCargosByFuncionarioQueryVariables> & ({ variables: GetCargosByFuncionarioQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCargosByFuncionarioQuery, GetCargosByFuncionarioQueryVariables>(GetCargosByFuncionarioDocument, options);
      }
export function useGetCargosByFuncionarioLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCargosByFuncionarioQuery, GetCargosByFuncionarioQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCargosByFuncionarioQuery, GetCargosByFuncionarioQueryVariables>(GetCargosByFuncionarioDocument, options);
        }
export function useGetCargosByFuncionarioSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCargosByFuncionarioQuery, GetCargosByFuncionarioQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCargosByFuncionarioQuery, GetCargosByFuncionarioQueryVariables>(GetCargosByFuncionarioDocument, options);
        }
export type GetCargosByFuncionarioQueryHookResult = ReturnType<typeof useGetCargosByFuncionarioQuery>;
export type GetCargosByFuncionarioLazyQueryHookResult = ReturnType<typeof useGetCargosByFuncionarioLazyQuery>;
export type GetCargosByFuncionarioSuspenseQueryHookResult = ReturnType<typeof useGetCargosByFuncionarioSuspenseQuery>;
export type GetCargosByFuncionarioQueryResult = Apollo.QueryResult<GetCargosByFuncionarioQuery, GetCargosByFuncionarioQueryVariables>;
export const GetFuncionariosByCargoDocument = gql`
    query GetFuncionariosByCargo($cargoId: Int!, $apenasAtivos: Boolean = true) {
  funcionariosByCargo(cargoId: $cargoId, apenasAtivos: $apenasAtivos) {
    ...FuncionarioCargoFields
  }
}
    ${FuncionarioCargoFieldsFragmentDoc}`;

/**
 * __useGetFuncionariosByCargoQuery__
 *
 * To run a query within a React component, call `useGetFuncionariosByCargoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFuncionariosByCargoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFuncionariosByCargoQuery({
 *   variables: {
 *      cargoId: // value for 'cargoId'
 *      apenasAtivos: // value for 'apenasAtivos'
 *   },
 * });
 */
export function useGetFuncionariosByCargoQuery(baseOptions: Apollo.QueryHookOptions<GetFuncionariosByCargoQuery, GetFuncionariosByCargoQueryVariables> & ({ variables: GetFuncionariosByCargoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFuncionariosByCargoQuery, GetFuncionariosByCargoQueryVariables>(GetFuncionariosByCargoDocument, options);
      }
export function useGetFuncionariosByCargoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFuncionariosByCargoQuery, GetFuncionariosByCargoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFuncionariosByCargoQuery, GetFuncionariosByCargoQueryVariables>(GetFuncionariosByCargoDocument, options);
        }
export function useGetFuncionariosByCargoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFuncionariosByCargoQuery, GetFuncionariosByCargoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFuncionariosByCargoQuery, GetFuncionariosByCargoQueryVariables>(GetFuncionariosByCargoDocument, options);
        }
export type GetFuncionariosByCargoQueryHookResult = ReturnType<typeof useGetFuncionariosByCargoQuery>;
export type GetFuncionariosByCargoLazyQueryHookResult = ReturnType<typeof useGetFuncionariosByCargoLazyQuery>;
export type GetFuncionariosByCargoSuspenseQueryHookResult = ReturnType<typeof useGetFuncionariosByCargoSuspenseQuery>;
export type GetFuncionariosByCargoQueryResult = Apollo.QueryResult<GetFuncionariosByCargoQuery, GetFuncionariosByCargoQueryVariables>;
export const GetRacasDocument = gql`
    query GetRacas {
  getRacas {
    id
    nome
    codigo
    descricao
  }
}
    `;

/**
 * __useGetRacasQuery__
 *
 * To run a query within a React component, call `useGetRacasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRacasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRacasQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRacasQuery(baseOptions?: Apollo.QueryHookOptions<GetRacasQuery, GetRacasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRacasQuery, GetRacasQueryVariables>(GetRacasDocument, options);
      }
export function useGetRacasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRacasQuery, GetRacasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRacasQuery, GetRacasQueryVariables>(GetRacasDocument, options);
        }
export function useGetRacasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRacasQuery, GetRacasQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRacasQuery, GetRacasQueryVariables>(GetRacasDocument, options);
        }
export type GetRacasQueryHookResult = ReturnType<typeof useGetRacasQuery>;
export type GetRacasLazyQueryHookResult = ReturnType<typeof useGetRacasLazyQuery>;
export type GetRacasSuspenseQueryHookResult = ReturnType<typeof useGetRacasSuspenseQuery>;
export type GetRacasQueryResult = Apollo.QueryResult<GetRacasQuery, GetRacasQueryVariables>;
export const GetTiposSanguineosDocument = gql`
    query GetTiposSanguineos {
  getTiposSanguineos {
    id
    tipo
    fatorRh
    nome
  }
}
    `;

/**
 * __useGetTiposSanguineosQuery__
 *
 * To run a query within a React component, call `useGetTiposSanguineosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTiposSanguineosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTiposSanguineosQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTiposSanguineosQuery(baseOptions?: Apollo.QueryHookOptions<GetTiposSanguineosQuery, GetTiposSanguineosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTiposSanguineosQuery, GetTiposSanguineosQueryVariables>(GetTiposSanguineosDocument, options);
      }
export function useGetTiposSanguineosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTiposSanguineosQuery, GetTiposSanguineosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTiposSanguineosQuery, GetTiposSanguineosQueryVariables>(GetTiposSanguineosDocument, options);
        }
export function useGetTiposSanguineosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTiposSanguineosQuery, GetTiposSanguineosQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTiposSanguineosQuery, GetTiposSanguineosQueryVariables>(GetTiposSanguineosDocument, options);
        }
export type GetTiposSanguineosQueryHookResult = ReturnType<typeof useGetTiposSanguineosQuery>;
export type GetTiposSanguineosLazyQueryHookResult = ReturnType<typeof useGetTiposSanguineosLazyQuery>;
export type GetTiposSanguineosSuspenseQueryHookResult = ReturnType<typeof useGetTiposSanguineosSuspenseQuery>;
export type GetTiposSanguineosQueryResult = Apollo.QueryResult<GetTiposSanguineosQuery, GetTiposSanguineosQueryVariables>;
export const GetEstadosCivisDocument = gql`
    query GetEstadosCivis {
  getEstadosCivis {
    id
    nome
  }
}
    `;

/**
 * __useGetEstadosCivisQuery__
 *
 * To run a query within a React component, call `useGetEstadosCivisQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEstadosCivisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEstadosCivisQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEstadosCivisQuery(baseOptions?: Apollo.QueryHookOptions<GetEstadosCivisQuery, GetEstadosCivisQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEstadosCivisQuery, GetEstadosCivisQueryVariables>(GetEstadosCivisDocument, options);
      }
export function useGetEstadosCivisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEstadosCivisQuery, GetEstadosCivisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEstadosCivisQuery, GetEstadosCivisQueryVariables>(GetEstadosCivisDocument, options);
        }
export function useGetEstadosCivisSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEstadosCivisQuery, GetEstadosCivisQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEstadosCivisQuery, GetEstadosCivisQueryVariables>(GetEstadosCivisDocument, options);
        }
export type GetEstadosCivisQueryHookResult = ReturnType<typeof useGetEstadosCivisQuery>;
export type GetEstadosCivisLazyQueryHookResult = ReturnType<typeof useGetEstadosCivisLazyQuery>;
export type GetEstadosCivisSuspenseQueryHookResult = ReturnType<typeof useGetEstadosCivisSuspenseQuery>;
export type GetEstadosCivisQueryResult = Apollo.QueryResult<GetEstadosCivisQuery, GetEstadosCivisQueryVariables>;
export const GetMultiDeficienciasDocument = gql`
    query GetMultiDeficiencias {
  multiDeficiencias {
    id
    nome
  }
}
    `;

/**
 * __useGetMultiDeficienciasQuery__
 *
 * To run a query within a React component, call `useGetMultiDeficienciasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMultiDeficienciasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMultiDeficienciasQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMultiDeficienciasQuery(baseOptions?: Apollo.QueryHookOptions<GetMultiDeficienciasQuery, GetMultiDeficienciasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMultiDeficienciasQuery, GetMultiDeficienciasQueryVariables>(GetMultiDeficienciasDocument, options);
      }
export function useGetMultiDeficienciasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMultiDeficienciasQuery, GetMultiDeficienciasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMultiDeficienciasQuery, GetMultiDeficienciasQueryVariables>(GetMultiDeficienciasDocument, options);
        }
export function useGetMultiDeficienciasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMultiDeficienciasQuery, GetMultiDeficienciasQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMultiDeficienciasQuery, GetMultiDeficienciasQueryVariables>(GetMultiDeficienciasDocument, options);
        }
export type GetMultiDeficienciasQueryHookResult = ReturnType<typeof useGetMultiDeficienciasQuery>;
export type GetMultiDeficienciasLazyQueryHookResult = ReturnType<typeof useGetMultiDeficienciasLazyQuery>;
export type GetMultiDeficienciasSuspenseQueryHookResult = ReturnType<typeof useGetMultiDeficienciasSuspenseQuery>;
export type GetMultiDeficienciasQueryResult = Apollo.QueryResult<GetMultiDeficienciasQuery, GetMultiDeficienciasQueryVariables>;
export const GetMunicipiosByUfDocument = gql`
    query GetMunicipiosByUF($uf: String!) {
  getMunicipiosByUF(uf: $uf) {
    id
    nome
    codigoIbge
    uf
    estado
  }
}
    `;

/**
 * __useGetMunicipiosByUfQuery__
 *
 * To run a query within a React component, call `useGetMunicipiosByUfQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMunicipiosByUfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMunicipiosByUfQuery({
 *   variables: {
 *      uf: // value for 'uf'
 *   },
 * });
 */
export function useGetMunicipiosByUfQuery(baseOptions: Apollo.QueryHookOptions<GetMunicipiosByUfQuery, GetMunicipiosByUfQueryVariables> & ({ variables: GetMunicipiosByUfQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMunicipiosByUfQuery, GetMunicipiosByUfQueryVariables>(GetMunicipiosByUfDocument, options);
      }
export function useGetMunicipiosByUfLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMunicipiosByUfQuery, GetMunicipiosByUfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMunicipiosByUfQuery, GetMunicipiosByUfQueryVariables>(GetMunicipiosByUfDocument, options);
        }
export function useGetMunicipiosByUfSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMunicipiosByUfQuery, GetMunicipiosByUfQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMunicipiosByUfQuery, GetMunicipiosByUfQueryVariables>(GetMunicipiosByUfDocument, options);
        }
export type GetMunicipiosByUfQueryHookResult = ReturnType<typeof useGetMunicipiosByUfQuery>;
export type GetMunicipiosByUfLazyQueryHookResult = ReturnType<typeof useGetMunicipiosByUfLazyQuery>;
export type GetMunicipiosByUfSuspenseQueryHookResult = ReturnType<typeof useGetMunicipiosByUfSuspenseQuery>;
export type GetMunicipiosByUfQueryResult = Apollo.QueryResult<GetMunicipiosByUfQuery, GetMunicipiosByUfQueryVariables>;
export const GetUFsDocument = gql`
    query GetUFs {
  getUFs {
    codigo
    nome
    sigla
  }
}
    `;

/**
 * __useGetUFsQuery__
 *
 * To run a query within a React component, call `useGetUFsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUFsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUFsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUFsQuery(baseOptions?: Apollo.QueryHookOptions<GetUFsQuery, GetUFsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUFsQuery, GetUFsQueryVariables>(GetUFsDocument, options);
      }
export function useGetUFsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUFsQuery, GetUFsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUFsQuery, GetUFsQueryVariables>(GetUFsDocument, options);
        }
export function useGetUFsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUFsQuery, GetUFsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUFsQuery, GetUFsQueryVariables>(GetUFsDocument, options);
        }
export type GetUFsQueryHookResult = ReturnType<typeof useGetUFsQuery>;
export type GetUFsLazyQueryHookResult = ReturnType<typeof useGetUFsLazyQuery>;
export type GetUFsSuspenseQueryHookResult = ReturnType<typeof useGetUFsSuspenseQuery>;
export type GetUFsQueryResult = Apollo.QueryResult<GetUFsQuery, GetUFsQueryVariables>;
export const GetNecessidadesEspeciaisDocument = gql`
    query GetNecessidadesEspeciais {
  getNecessidadesEspeciais {
    id
    codigo
    nome
    descricao
    categoria
  }
}
    `;

/**
 * __useGetNecessidadesEspeciaisQuery__
 *
 * To run a query within a React component, call `useGetNecessidadesEspeciaisQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNecessidadesEspeciaisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNecessidadesEspeciaisQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNecessidadesEspeciaisQuery(baseOptions?: Apollo.QueryHookOptions<GetNecessidadesEspeciaisQuery, GetNecessidadesEspeciaisQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNecessidadesEspeciaisQuery, GetNecessidadesEspeciaisQueryVariables>(GetNecessidadesEspeciaisDocument, options);
      }
export function useGetNecessidadesEspeciaisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNecessidadesEspeciaisQuery, GetNecessidadesEspeciaisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNecessidadesEspeciaisQuery, GetNecessidadesEspeciaisQueryVariables>(GetNecessidadesEspeciaisDocument, options);
        }
export function useGetNecessidadesEspeciaisSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNecessidadesEspeciaisQuery, GetNecessidadesEspeciaisQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNecessidadesEspeciaisQuery, GetNecessidadesEspeciaisQueryVariables>(GetNecessidadesEspeciaisDocument, options);
        }
export type GetNecessidadesEspeciaisQueryHookResult = ReturnType<typeof useGetNecessidadesEspeciaisQuery>;
export type GetNecessidadesEspeciaisLazyQueryHookResult = ReturnType<typeof useGetNecessidadesEspeciaisLazyQuery>;
export type GetNecessidadesEspeciaisSuspenseQueryHookResult = ReturnType<typeof useGetNecessidadesEspeciaisSuspenseQuery>;
export type GetNecessidadesEspeciaisQueryResult = Apollo.QueryResult<GetNecessidadesEspeciaisQuery, GetNecessidadesEspeciaisQueryVariables>;
export const GetGrausParentescoDocument = gql`
    query GetGrausParentesco {
  getGrausParentesco {
    id
    nome
    categoria
    prioridade
  }
}
    `;

/**
 * __useGetGrausParentescoQuery__
 *
 * To run a query within a React component, call `useGetGrausParentescoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGrausParentescoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGrausParentescoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGrausParentescoQuery(baseOptions?: Apollo.QueryHookOptions<GetGrausParentescoQuery, GetGrausParentescoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGrausParentescoQuery, GetGrausParentescoQueryVariables>(GetGrausParentescoDocument, options);
      }
export function useGetGrausParentescoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGrausParentescoQuery, GetGrausParentescoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGrausParentescoQuery, GetGrausParentescoQueryVariables>(GetGrausParentescoDocument, options);
        }
export function useGetGrausParentescoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGrausParentescoQuery, GetGrausParentescoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGrausParentescoQuery, GetGrausParentescoQueryVariables>(GetGrausParentescoDocument, options);
        }
export type GetGrausParentescoQueryHookResult = ReturnType<typeof useGetGrausParentescoQuery>;
export type GetGrausParentescoLazyQueryHookResult = ReturnType<typeof useGetGrausParentescoLazyQuery>;
export type GetGrausParentescoSuspenseQueryHookResult = ReturnType<typeof useGetGrausParentescoSuspenseQuery>;
export type GetGrausParentescoQueryResult = Apollo.QueryResult<GetGrausParentescoQuery, GetGrausParentescoQueryVariables>;
export const GetPessoaCompletaDocument = gql`
    query GetPessoaCompleta($pessoaId: Int!) {
  pessoaCompleta(pessoaId: $pessoaId) {
    pessoa {
      id
      nome
      nomeSocial
      cpf
      dataNascimento
      email
      telefoneCelular
      telefoneFixo
      genero
      fotoUrl
      nomePai
      nomeMae
      emancipado
      rg
      orgaoEmissor
      dataEmissaoRg
      cartaoSus
      isRural
      cep
      logradouro
      numero
      complemento
      bairro
      cidade {
        id
        nome
        uf
      }
      nacionalidade
      naturalidade {
        id
        nome
        uf
      }
      profissao
      escolaridade
      religiao
      localTrabalho
      pontoReferencia
      certidaoMatricula
      certidaoTipo
      certidaoTermo
      certidaoLivro
      certidaoFolha
      certidaoCartorio
      certidaoMunicipio
      certidaoUf
      certidaoDataEmissao
      nis
      passaporte
      raca {
        id
        nome
      }
      status
      tipoSanguineo {
        id
        nome
      }
      tituloEleitor
      zonaResidencial
      certidaoNascimento
      dataChegadaBrasil
      idiomaNativo
      user {
        id
        username
      }
      criadoEm
      atualizadoEm
    }
    user {
      id
      username
      email
      ativo
      criadoEm
    }
    vinculos {
      id
      ativo
      role {
        id
        nome
      }
      escola {
        id
        nomeFantasia
      }
      secretaria {
        id
        nome
      }
    }
    funcionario {
      id
      matriculaFuncional
      dataAdmissao
      status
      escola {
        id
        nomeFantasia
      }
      cargos {
        id
        funcionarioId
        cargoId
        dataInicio
        dataFim
        cargaHorariaSemanal
        cargoPrincipal
        ativo
        salario
        cargo {
          id
          nome
          categoria
          descricao
        }
      }
    }
    aluno {
      id
      matricula
      codigoInep
      matriculaLegado
      escolaOrigem
      modalidadeEnsino
      recebeBolsaFamilia
      autorizaUsoImagem
      laudoNeeEntregue
      possuiNee
      responsavelGuarda
      pessoaId
      necessidadesEspeciais
      recursosAcessibilidade
      escolarizacaoForaEscola
      justificativaFaltaDocumento
      usaTransporteEscolar
      restricoesAlimentares
      rotaTransporteId
      responsaveis {
        id
        pessoa {
          id
          nome
          nomeSocial
          cpf
          email
          telefoneCelular
          telefoneFixo
          profissao
          escolaridade
          localTrabalho
          fotoUrl
          status
        }
        grauParentesco
        responsavelLegal
        responsavelFinanceiro
        responsavelAcademico
        autorizadoBuscar
        contatoEmergencia
        guardaCompartilhada
        prioridadeContato
        observacoes
        ativo
      }
      fichaMedica {
        id
        alunoId
        alergias
        condicoesMedicas
        contatoEmergenciaNome
        contatoEmergenciaTelefone
        contatoEmergenciaParentesco
        laudosMedicos
        medicamentosContinuos
        emTratamentoMedico
        tiposTratamentoMedico
        doencasAnteriores
        tipoSanguineo
      }
      pessoasAutorizadas {
        id
        alunoId
        nome
        documento
        parentesco
      }
      matriculas {
        id
        status
        turma {
          id
          nome
          escola {
            id
            nomeFantasia
          }
        }
      }
    }
    responsavel {
      id
    }
    contextInfo {
      isAluno
      isFuncionario
      isResponsavel
      escolaIds
      secretariaId
      activeRole
      canSwitchRoles
    }
    permissoes
  }
}
    `;

/**
 * __useGetPessoaCompletaQuery__
 *
 * To run a query within a React component, call `useGetPessoaCompletaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPessoaCompletaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPessoaCompletaQuery({
 *   variables: {
 *      pessoaId: // value for 'pessoaId'
 *   },
 * });
 */
export function useGetPessoaCompletaQuery(baseOptions: Apollo.QueryHookOptions<GetPessoaCompletaQuery, GetPessoaCompletaQueryVariables> & ({ variables: GetPessoaCompletaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPessoaCompletaQuery, GetPessoaCompletaQueryVariables>(GetPessoaCompletaDocument, options);
      }
export function useGetPessoaCompletaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPessoaCompletaQuery, GetPessoaCompletaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPessoaCompletaQuery, GetPessoaCompletaQueryVariables>(GetPessoaCompletaDocument, options);
        }
export function useGetPessoaCompletaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPessoaCompletaQuery, GetPessoaCompletaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPessoaCompletaQuery, GetPessoaCompletaQueryVariables>(GetPessoaCompletaDocument, options);
        }
export type GetPessoaCompletaQueryHookResult = ReturnType<typeof useGetPessoaCompletaQuery>;
export type GetPessoaCompletaLazyQueryHookResult = ReturnType<typeof useGetPessoaCompletaLazyQuery>;
export type GetPessoaCompletaSuspenseQueryHookResult = ReturnType<typeof useGetPessoaCompletaSuspenseQuery>;
export type GetPessoaCompletaQueryResult = Apollo.QueryResult<GetPessoaCompletaQuery, GetPessoaCompletaQueryVariables>;
export const SearchPessoasInteligenteDocument = gql`
    query SearchPessoasInteligente($query: String!, $limit: Int = 10) {
  pessoas(where: {nome: $query}, pagination: {page: 1, limit: $limit}) {
    data {
      ...PessoaBasicFields
    }
  }
}
    ${PessoaBasicFieldsFragmentDoc}`;

/**
 * __useSearchPessoasInteligenteQuery__
 *
 * To run a query within a React component, call `useSearchPessoasInteligenteQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPessoasInteligenteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchPessoasInteligenteQuery({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchPessoasInteligenteQuery(baseOptions: Apollo.QueryHookOptions<SearchPessoasInteligenteQuery, SearchPessoasInteligenteQueryVariables> & ({ variables: SearchPessoasInteligenteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchPessoasInteligenteQuery, SearchPessoasInteligenteQueryVariables>(SearchPessoasInteligenteDocument, options);
      }
export function useSearchPessoasInteligenteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchPessoasInteligenteQuery, SearchPessoasInteligenteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchPessoasInteligenteQuery, SearchPessoasInteligenteQueryVariables>(SearchPessoasInteligenteDocument, options);
        }
export function useSearchPessoasInteligenteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchPessoasInteligenteQuery, SearchPessoasInteligenteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchPessoasInteligenteQuery, SearchPessoasInteligenteQueryVariables>(SearchPessoasInteligenteDocument, options);
        }
export type SearchPessoasInteligenteQueryHookResult = ReturnType<typeof useSearchPessoasInteligenteQuery>;
export type SearchPessoasInteligenteLazyQueryHookResult = ReturnType<typeof useSearchPessoasInteligenteLazyQuery>;
export type SearchPessoasInteligenteSuspenseQueryHookResult = ReturnType<typeof useSearchPessoasInteligenteSuspenseQuery>;
export type SearchPessoasInteligenteQueryResult = Apollo.QueryResult<SearchPessoasInteligenteQuery, SearchPessoasInteligenteQueryVariables>;
export const GetAllPessoasForSearchDocument = gql`
    query GetAllPessoasForSearch($limit: Int = 100) {
  pessoas(pagination: {page: 1, limit: $limit}) {
    data {
      ...PessoaBasicFields
    }
  }
}
    ${PessoaBasicFieldsFragmentDoc}`;

/**
 * __useGetAllPessoasForSearchQuery__
 *
 * To run a query within a React component, call `useGetAllPessoasForSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPessoasForSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPessoasForSearchQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetAllPessoasForSearchQuery(baseOptions?: Apollo.QueryHookOptions<GetAllPessoasForSearchQuery, GetAllPessoasForSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllPessoasForSearchQuery, GetAllPessoasForSearchQueryVariables>(GetAllPessoasForSearchDocument, options);
      }
export function useGetAllPessoasForSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllPessoasForSearchQuery, GetAllPessoasForSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllPessoasForSearchQuery, GetAllPessoasForSearchQueryVariables>(GetAllPessoasForSearchDocument, options);
        }
export function useGetAllPessoasForSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllPessoasForSearchQuery, GetAllPessoasForSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllPessoasForSearchQuery, GetAllPessoasForSearchQueryVariables>(GetAllPessoasForSearchDocument, options);
        }
export type GetAllPessoasForSearchQueryHookResult = ReturnType<typeof useGetAllPessoasForSearchQuery>;
export type GetAllPessoasForSearchLazyQueryHookResult = ReturnType<typeof useGetAllPessoasForSearchLazyQuery>;
export type GetAllPessoasForSearchSuspenseQueryHookResult = ReturnType<typeof useGetAllPessoasForSearchSuspenseQuery>;
export type GetAllPessoasForSearchQueryResult = Apollo.QueryResult<GetAllPessoasForSearchQuery, GetAllPessoasForSearchQueryVariables>;
export const GetPessoaVinculosDocument = gql`
    query GetPessoaVinculos($pessoaId: Int!) {
  pessoa(id: $pessoaId) {
    ...PessoaFields
  }
  vinculos(where: {userId: $pessoaId}) {
    data {
      id
      ativo
      role {
        id
        nome
      }
      escola {
        id
        nomeFantasia
      }
      secretaria {
        id
        nome
      }
      user {
        id
        username
        pessoa {
          ...PessoaBasicFields
        }
      }
    }
  }
}
    ${PessoaFieldsFragmentDoc}
${PessoaBasicFieldsFragmentDoc}`;

/**
 * __useGetPessoaVinculosQuery__
 *
 * To run a query within a React component, call `useGetPessoaVinculosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPessoaVinculosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPessoaVinculosQuery({
 *   variables: {
 *      pessoaId: // value for 'pessoaId'
 *   },
 * });
 */
export function useGetPessoaVinculosQuery(baseOptions: Apollo.QueryHookOptions<GetPessoaVinculosQuery, GetPessoaVinculosQueryVariables> & ({ variables: GetPessoaVinculosQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPessoaVinculosQuery, GetPessoaVinculosQueryVariables>(GetPessoaVinculosDocument, options);
      }
export function useGetPessoaVinculosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPessoaVinculosQuery, GetPessoaVinculosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPessoaVinculosQuery, GetPessoaVinculosQueryVariables>(GetPessoaVinculosDocument, options);
        }
export function useGetPessoaVinculosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPessoaVinculosQuery, GetPessoaVinculosQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPessoaVinculosQuery, GetPessoaVinculosQueryVariables>(GetPessoaVinculosDocument, options);
        }
export type GetPessoaVinculosQueryHookResult = ReturnType<typeof useGetPessoaVinculosQuery>;
export type GetPessoaVinculosLazyQueryHookResult = ReturnType<typeof useGetPessoaVinculosLazyQuery>;
export type GetPessoaVinculosSuspenseQueryHookResult = ReturnType<typeof useGetPessoaVinculosSuspenseQuery>;
export type GetPessoaVinculosQueryResult = Apollo.QueryResult<GetPessoaVinculosQuery, GetPessoaVinculosQueryVariables>;
export const GetUserCompleteDocument = gql`
    query GetUserComplete($userId: Int!) {
  user(id: $userId) {
    ...UserCompleteFields
  }
}
    ${UserCompleteFieldsFragmentDoc}`;

/**
 * __useGetUserCompleteQuery__
 *
 * To run a query within a React component, call `useGetUserCompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserCompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserCompleteQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserCompleteQuery(baseOptions: Apollo.QueryHookOptions<GetUserCompleteQuery, GetUserCompleteQueryVariables> & ({ variables: GetUserCompleteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserCompleteQuery, GetUserCompleteQueryVariables>(GetUserCompleteDocument, options);
      }
export function useGetUserCompleteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserCompleteQuery, GetUserCompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserCompleteQuery, GetUserCompleteQueryVariables>(GetUserCompleteDocument, options);
        }
export function useGetUserCompleteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserCompleteQuery, GetUserCompleteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserCompleteQuery, GetUserCompleteQueryVariables>(GetUserCompleteDocument, options);
        }
export type GetUserCompleteQueryHookResult = ReturnType<typeof useGetUserCompleteQuery>;
export type GetUserCompleteLazyQueryHookResult = ReturnType<typeof useGetUserCompleteLazyQuery>;
export type GetUserCompleteSuspenseQueryHookResult = ReturnType<typeof useGetUserCompleteSuspenseQuery>;
export type GetUserCompleteQueryResult = Apollo.QueryResult<GetUserCompleteQuery, GetUserCompleteQueryVariables>;
export const GetUsersForPessoaDocument = gql`
    query GetUsersForPessoa($pagination: PaginationInput, $where: UserWhereInput) {
  users(pagination: $pagination, where: $where) {
    data {
      ...UserFields
    }
    meta {
      total
      pageCount
      page
      limit
    }
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetUsersForPessoaQuery__
 *
 * To run a query within a React component, call `useGetUsersForPessoaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersForPessoaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersForPessoaQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetUsersForPessoaQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersForPessoaQuery, GetUsersForPessoaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersForPessoaQuery, GetUsersForPessoaQueryVariables>(GetUsersForPessoaDocument, options);
      }
export function useGetUsersForPessoaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersForPessoaQuery, GetUsersForPessoaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersForPessoaQuery, GetUsersForPessoaQueryVariables>(GetUsersForPessoaDocument, options);
        }
export function useGetUsersForPessoaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersForPessoaQuery, GetUsersForPessoaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsersForPessoaQuery, GetUsersForPessoaQueryVariables>(GetUsersForPessoaDocument, options);
        }
export type GetUsersForPessoaQueryHookResult = ReturnType<typeof useGetUsersForPessoaQuery>;
export type GetUsersForPessoaLazyQueryHookResult = ReturnType<typeof useGetUsersForPessoaLazyQuery>;
export type GetUsersForPessoaSuspenseQueryHookResult = ReturnType<typeof useGetUsersForPessoaSuspenseQuery>;
export type GetUsersForPessoaQueryResult = Apollo.QueryResult<GetUsersForPessoaQuery, GetUsersForPessoaQueryVariables>;
export const GetVinculosByUserDocument = gql`
    query GetVinculosByUser($userId: Int!) {
  vinculos(where: {userId: $userId}) {
    data {
      ...VinculoFields
    }
  }
}
    ${VinculoFieldsFragmentDoc}`;

/**
 * __useGetVinculosByUserQuery__
 *
 * To run a query within a React component, call `useGetVinculosByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVinculosByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVinculosByUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetVinculosByUserQuery(baseOptions: Apollo.QueryHookOptions<GetVinculosByUserQuery, GetVinculosByUserQueryVariables> & ({ variables: GetVinculosByUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVinculosByUserQuery, GetVinculosByUserQueryVariables>(GetVinculosByUserDocument, options);
      }
export function useGetVinculosByUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVinculosByUserQuery, GetVinculosByUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVinculosByUserQuery, GetVinculosByUserQueryVariables>(GetVinculosByUserDocument, options);
        }
export function useGetVinculosByUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVinculosByUserQuery, GetVinculosByUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVinculosByUserQuery, GetVinculosByUserQueryVariables>(GetVinculosByUserDocument, options);
        }
export type GetVinculosByUserQueryHookResult = ReturnType<typeof useGetVinculosByUserQuery>;
export type GetVinculosByUserLazyQueryHookResult = ReturnType<typeof useGetVinculosByUserLazyQuery>;
export type GetVinculosByUserSuspenseQueryHookResult = ReturnType<typeof useGetVinculosByUserSuspenseQuery>;
export type GetVinculosByUserQueryResult = Apollo.QueryResult<GetVinculosByUserQuery, GetVinculosByUserQueryVariables>;
export const GetVinculosRolesByEscolaDocument = gql`
    query GetVinculosRolesByEscola($escolaId: Int!) {
  vinculos(
    where: {escolaId: $escolaId, ativo: true}
    pagination: {page: 1, limit: 500}
  ) {
    data {
      id
      userId
      roleId
      role {
        id
        nome
      }
    }
    meta {
      total
    }
  }
}
    `;

/**
 * __useGetVinculosRolesByEscolaQuery__
 *
 * To run a query within a React component, call `useGetVinculosRolesByEscolaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVinculosRolesByEscolaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVinculosRolesByEscolaQuery({
 *   variables: {
 *      escolaId: // value for 'escolaId'
 *   },
 * });
 */
export function useGetVinculosRolesByEscolaQuery(baseOptions: Apollo.QueryHookOptions<GetVinculosRolesByEscolaQuery, GetVinculosRolesByEscolaQueryVariables> & ({ variables: GetVinculosRolesByEscolaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVinculosRolesByEscolaQuery, GetVinculosRolesByEscolaQueryVariables>(GetVinculosRolesByEscolaDocument, options);
      }
export function useGetVinculosRolesByEscolaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVinculosRolesByEscolaQuery, GetVinculosRolesByEscolaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVinculosRolesByEscolaQuery, GetVinculosRolesByEscolaQueryVariables>(GetVinculosRolesByEscolaDocument, options);
        }
export function useGetVinculosRolesByEscolaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVinculosRolesByEscolaQuery, GetVinculosRolesByEscolaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVinculosRolesByEscolaQuery, GetVinculosRolesByEscolaQueryVariables>(GetVinculosRolesByEscolaDocument, options);
        }
export type GetVinculosRolesByEscolaQueryHookResult = ReturnType<typeof useGetVinculosRolesByEscolaQuery>;
export type GetVinculosRolesByEscolaLazyQueryHookResult = ReturnType<typeof useGetVinculosRolesByEscolaLazyQuery>;
export type GetVinculosRolesByEscolaSuspenseQueryHookResult = ReturnType<typeof useGetVinculosRolesByEscolaSuspenseQuery>;
export type GetVinculosRolesByEscolaQueryResult = Apollo.QueryResult<GetVinculosRolesByEscolaQuery, GetVinculosRolesByEscolaQueryVariables>;
export const GetVinculosRolesBySecretariaDocument = gql`
    query GetVinculosRolesBySecretaria($secretariaId: Int!) {
  vinculos(
    where: {secretariaId: $secretariaId, ativo: true}
    pagination: {page: 1, limit: 2000}
  ) {
    data {
      id
      userId
      roleId
      role {
        id
        nome
      }
    }
    meta {
      total
    }
  }
}
    `;

/**
 * __useGetVinculosRolesBySecretariaQuery__
 *
 * To run a query within a React component, call `useGetVinculosRolesBySecretariaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVinculosRolesBySecretariaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVinculosRolesBySecretariaQuery({
 *   variables: {
 *      secretariaId: // value for 'secretariaId'
 *   },
 * });
 */
export function useGetVinculosRolesBySecretariaQuery(baseOptions: Apollo.QueryHookOptions<GetVinculosRolesBySecretariaQuery, GetVinculosRolesBySecretariaQueryVariables> & ({ variables: GetVinculosRolesBySecretariaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVinculosRolesBySecretariaQuery, GetVinculosRolesBySecretariaQueryVariables>(GetVinculosRolesBySecretariaDocument, options);
      }
export function useGetVinculosRolesBySecretariaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVinculosRolesBySecretariaQuery, GetVinculosRolesBySecretariaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVinculosRolesBySecretariaQuery, GetVinculosRolesBySecretariaQueryVariables>(GetVinculosRolesBySecretariaDocument, options);
        }
export function useGetVinculosRolesBySecretariaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVinculosRolesBySecretariaQuery, GetVinculosRolesBySecretariaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVinculosRolesBySecretariaQuery, GetVinculosRolesBySecretariaQueryVariables>(GetVinculosRolesBySecretariaDocument, options);
        }
export type GetVinculosRolesBySecretariaQueryHookResult = ReturnType<typeof useGetVinculosRolesBySecretariaQuery>;
export type GetVinculosRolesBySecretariaLazyQueryHookResult = ReturnType<typeof useGetVinculosRolesBySecretariaLazyQuery>;
export type GetVinculosRolesBySecretariaSuspenseQueryHookResult = ReturnType<typeof useGetVinculosRolesBySecretariaSuspenseQuery>;
export type GetVinculosRolesBySecretariaQueryResult = Apollo.QueryResult<GetVinculosRolesBySecretariaQuery, GetVinculosRolesBySecretariaQueryVariables>;
export const ValidarCpfDocument = gql`
    query ValidarCPF($cpf: String!, $excludeId: Int) {
  validarCPF(cpf: $cpf, excludeId: $excludeId) {
    valido
    motivo
    pessoaExistente {
      id
      nome
      cpf
      email
    }
  }
}
    `;

/**
 * __useValidarCpfQuery__
 *
 * To run a query within a React component, call `useValidarCpfQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidarCpfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidarCpfQuery({
 *   variables: {
 *      cpf: // value for 'cpf'
 *      excludeId: // value for 'excludeId'
 *   },
 * });
 */
export function useValidarCpfQuery(baseOptions: Apollo.QueryHookOptions<ValidarCpfQuery, ValidarCpfQueryVariables> & ({ variables: ValidarCpfQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidarCpfQuery, ValidarCpfQueryVariables>(ValidarCpfDocument, options);
      }
export function useValidarCpfLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidarCpfQuery, ValidarCpfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidarCpfQuery, ValidarCpfQueryVariables>(ValidarCpfDocument, options);
        }
export function useValidarCpfSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidarCpfQuery, ValidarCpfQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidarCpfQuery, ValidarCpfQueryVariables>(ValidarCpfDocument, options);
        }
export type ValidarCpfQueryHookResult = ReturnType<typeof useValidarCpfQuery>;
export type ValidarCpfLazyQueryHookResult = ReturnType<typeof useValidarCpfLazyQuery>;
export type ValidarCpfSuspenseQueryHookResult = ReturnType<typeof useValidarCpfSuspenseQuery>;
export type ValidarCpfQueryResult = Apollo.QueryResult<ValidarCpfQuery, ValidarCpfQueryVariables>;
export const VerificarDuplicatasDocument = gql`
    query VerificarDuplicatas($data: VerificarDuplicatasInput!, $excludeId: Int) {
  verificarDuplicatas(data: $data, excludeId: $excludeId) {
    podeProcessar
    recomendacao
    duplicatas {
      campo
      tipoConflito
      valor
      percentualSimilaridade
      pessoaExistente {
        id
        nome
        cpf
        email
      }
    }
  }
}
    `;

/**
 * __useVerificarDuplicatasQuery__
 *
 * To run a query within a React component, call `useVerificarDuplicatasQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerificarDuplicatasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerificarDuplicatasQuery({
 *   variables: {
 *      data: // value for 'data'
 *      excludeId: // value for 'excludeId'
 *   },
 * });
 */
export function useVerificarDuplicatasQuery(baseOptions: Apollo.QueryHookOptions<VerificarDuplicatasQuery, VerificarDuplicatasQueryVariables> & ({ variables: VerificarDuplicatasQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VerificarDuplicatasQuery, VerificarDuplicatasQueryVariables>(VerificarDuplicatasDocument, options);
      }
export function useVerificarDuplicatasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VerificarDuplicatasQuery, VerificarDuplicatasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VerificarDuplicatasQuery, VerificarDuplicatasQueryVariables>(VerificarDuplicatasDocument, options);
        }
export function useVerificarDuplicatasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VerificarDuplicatasQuery, VerificarDuplicatasQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VerificarDuplicatasQuery, VerificarDuplicatasQueryVariables>(VerificarDuplicatasDocument, options);
        }
export type VerificarDuplicatasQueryHookResult = ReturnType<typeof useVerificarDuplicatasQuery>;
export type VerificarDuplicatasLazyQueryHookResult = ReturnType<typeof useVerificarDuplicatasLazyQuery>;
export type VerificarDuplicatasSuspenseQueryHookResult = ReturnType<typeof useVerificarDuplicatasSuspenseQuery>;
export type VerificarDuplicatasQueryResult = Apollo.QueryResult<VerificarDuplicatasQuery, VerificarDuplicatasQueryVariables>;